  (function () {
    window.BasedBYOBPremium = window.BasedBYOBPremium || {};
    window.BasedBYOB = window.BasedBYOBPremium;
    if (window.BasedBYOBPremium.initialized) return;
    window.BasedBYOBPremium.initialized = true;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    window.BasedBYOBPremium.prefersReducedMotion = prefersReducedMotion;

    function initLenis() {
      // Native scroll stays on. Sandbox QA showed Lenis could stutter under Shopify preview chrome.
      return null;
    }

    window.BasedBYOBPremium.initLenis = initLenis;

    function createCheckoutGuard() {
      var inFlight = false;
      return {
        begin: function () {
          if (inFlight) return false;
          inFlight = true;
          return true;
        },
        end: function () {
          inFlight = false;
        },
        pending: function () {
          return inFlight;
        }
      };
    }

    window.BasedBYOBPremium.createCheckoutGuard = createCheckoutGuard;

    function checkoutErrorTarget(elements, isDrawer, isMobile) {
      return (isDrawer || isMobile) ? elements.drawerError : elements.error;
    }

    window.BasedBYOBPremium.checkoutErrorTarget = checkoutErrorTarget;

    // Intelligems price-test bridge. API values are currency-unit strings
    // (for example "29.95"), while the builder calculates in cents.
    function igResolvePriceCents(variantId, nativeCents) {
      try {
        var api = window.igData && window.igData.price;
        if (api && typeof api.getPriceByVariantId === 'function' && variantId != null) {
          var value = api.getPriceByVariantId(variantId);
          if (value != null && value !== '') {
            var dollars = Number(value);
            if (isFinite(dollars)) return Math.round(dollars * 100);
          }
        }
      } catch (e) {}
      return Number(nativeCents || 0);
    }

    function igResolveCompareCents(variantId, nativeCents) {
      try {
        var api = window.igData && window.igData.price;
        if (api && typeof api.getComparePriceByVariantId === 'function' && variantId != null) {
          var value = api.getComparePriceByVariantId(variantId);
          if (value != null && value !== '') {
            var dollars = Number(value);
            if (isFinite(dollars)) return Math.round(dollars * 100);
          }
        }
      } catch (e) {}
      return Number(nativeCents || 0);
    }

    function syncCardPriceBinding(card, variant, formatMoney) {
      if (!card || !variant || typeof formatMoney !== 'function') return;
      var binding = card.querySelector('.based-byob-pp__card-price, .bbw-pcard__price');
      if (!binding) return;

      binding.setAttribute('data-variant-id', variant.id);
      var priceCents = igResolvePriceCents(variant.id, variant.price);
      var compareCents = igResolveCompareCents(variant.id, variant.compareAt);
      var priceEl = binding.querySelector('.igPrice');
      var compareEl = binding.querySelector('.igComparePrice');
      if (priceEl) priceEl.textContent = formatMoney(priceCents);
      if (compareEl) {
        compareEl.hidden = !(compareCents > priceCents);
        compareEl.textContent = compareEl.hidden ? '' : formatMoney(compareCents);
      }
    }

    window.BasedBYOBPremium.syncCardPriceBinding = syncCardPriceBinding;

    function editScent(selections, index, newVariantId, newScentValue, newImage, newPrice) {
      return selections.map(function (s, i) {
        if (i !== index) return s;
        var copy = {};
        for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) copy[k] = s[k]; }
        copy.variantId = newVariantId;
        copy.scentValue = newScentValue;
        if (newImage) copy.image = newImage;
        if (newPrice != null && isFinite(Number(newPrice))) copy.price = Number(newPrice);
        return copy;
      });
    }

    window.BasedBYOBPremium.editScent = editScent;

    function findCardVariant(variants, pickedScent) {
      var list = variants || [];
      var match = null;

      if (pickedScent) {
        list.forEach(function (variant) {
          if (!match && variant.scent === pickedScent) match = variant;
        });
        return match;
      }

      list.forEach(function (variant) {
        if (!match && variant.available) match = variant;
      });
      return match;
    }

    function countSelectionsForVariant(selections, variantId) {
      if (variantId == null) return 0;
      return (selections || []).reduce(function (count, selection) {
        return count + (String(selection.variantId) === String(variantId) ? 1 : 0);
      }, 0);
    }

    function lastSelectionIndexForVariant(selections, variantId) {
      if (variantId == null) return -1;
      for (var i = (selections || []).length - 1; i >= 0; i -= 1) {
        if (String(selections[i].variantId) === String(variantId)) return i;
      }
      return -1;
    }

    window.BasedBYOBPremium.findCardVariant = findCardVariant;
    window.BasedBYOBPremium.countSelectionsForVariant = countSelectionsForVariant;
    window.BasedBYOBPremium.lastSelectionIndexForVariant = lastSelectionIndexForVariant;

    function createMoneyFormatter(currencyCode, currencySymbol, locale) {
      return function (cents) {
        var amount = Math.round(Number(cents) || 0) / 100;
        try {
          return new Intl.NumberFormat(locale || undefined, {
            style: 'currency',
            currency: currencyCode || 'USD'
          }).format(amount);
        } catch (e) {
          var zeroDecimal = /^(JPY|KRW|VND|CLP|ISK|TWD|XOF|XAF)$/.test(currencyCode || '');
          var digits = zeroDecimal ? 0 : 2;
          return (currencySymbol || '$') + amount.toLocaleString('en-US', {
            minimumFractionDigits: digits,
            maximumFractionDigits: digits
          });
        }
      };
    }

    window.BasedBYOBPremium.createMoneyFormatter = createMoneyFormatter;

    var bodyScrollLock = {
      count: 0,
      overflow: '',
      paddingRight: ''
    };

    function lockBodyScroll() {
      if (bodyScrollLock.count === 0) {
        var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        var currentPadding = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        bodyScrollLock.overflow = document.body.style.overflow;
        bodyScrollLock.paddingRight = document.body.style.paddingRight;
        document.body.style.overflow = 'hidden';
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = (currentPadding + scrollbarWidth) + 'px';
        }
      }
      bodyScrollLock.count += 1;
    }

    function unlockBodyScroll() {
      if (bodyScrollLock.count === 0) return;
      bodyScrollLock.count -= 1;
      if (bodyScrollLock.count === 0) {
        document.body.style.overflow = bodyScrollLock.overflow;
        document.body.style.paddingRight = bodyScrollLock.paddingRight;
      }
    }

    function initCardTilt(root) {}

    function findNextEmptySlot(root) {
      var slots = root.querySelectorAll('[data-byob-slot]');
      var fallback = null;
      for (var i = 0; i < slots.length; i++) {
        if (!slots[i].classList.contains('based-byob-pp__slot--empty')) continue;
        if (!fallback) fallback = slots[i];
        var rect = slots[i].getBoundingClientRect();
        if (rect.width && rect.height) return slots[i];
      }
      return fallback;
    }

    window.BasedBYOBPremium.findNextEmptySlot = findNextEmptySlot;

    function initGlobalEscapeClose() {
      if (window.BasedBYOBPremium.escapeCloseBound) return;
      window.BasedBYOBPremium.escapeCloseBound = true;

      window.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var drawer = document.querySelector('section.based-byob-pp [data-byob-drawer][data-open="1"]');
        if (!drawer) return;
        var closeBtn = drawer.querySelector('[data-byob-drawer-close]');
        if (!closeBtn) return;
        e.preventDefault();
        closeBtn.click();
      });
    }

    function initGlobalDrawerDrag() {
      if (window.BasedBYOBPremium.drawerDragBound) return;
      window.BasedBYOBPremium.drawerDragBound = true;

      var active = null;

      function elementFromTarget(target) {
        if (!target) return null;
        if (target.nodeType === 1) return target;
        return target.parentElement || null;
      }

      function pointY(e, changed) {
        if (changed && e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].clientY;
        if (e.touches && e.touches[0]) return e.touches[0].clientY;
        return e.clientY;
      }

      function onDown(e) {
        if (active) return;
        var target = elementFromTarget(e.target);
        var grabber = target && target.closest('section.based-byob-pp [data-byob-drawer-grabber]');
        if (!grabber) return;
        var drawer = grabber.closest('[data-byob-drawer]');
        var panel = drawer && drawer.querySelector('.based-byob-pp__drawer-panel');
        if (!drawer || !panel || drawer.getAttribute('data-open') !== '1') return;

        active = {
          drawer: drawer,
          panel: panel,
          startY: pointY(e, false),
          startTime: Date.now(),
          panelHeight: panel.getBoundingClientRect().height
        };
        drawer.setAttribute('data-dragging', '1');
      }

      function onMove(e) {
        if (!active) return;
        var dy = pointY(e, false) - active.startY;
        if (dy < 0) dy = -Math.pow(-dy, 0.6);
        active.panel.style.transform = 'translateY(' + Math.max(dy, -16) + 'px)';
      }

      function onUp(e) {
        if (!active) return;
        var current = active;
        active = null;
        current.drawer.removeAttribute('data-dragging');
        var dy = pointY(e, true) - current.startY;
        var ms = Math.max(1, Date.now() - current.startTime);
        var velocity = dy / ms;
        var snap = current.drawer.getAttribute('data-snap') || 'peek';
        current.panel.style.transform = '';
        if (snap === 'peek' && dy < -48) {
          current.drawer.setAttribute('data-snap', 'full');
          return;
        }
        if (snap === 'full' && dy > 64 && velocity < 0.5) {
          current.drawer.setAttribute('data-snap', 'peek');
          return;
        }
        if (dy > current.panelHeight * 0.25 || velocity > 0.5) {
          var closeBtn = current.drawer.querySelector('[data-byob-drawer-close]');
          if (closeBtn) closeBtn.click();
        }
      }

      document.addEventListener('pointerdown', onDown);
      document.addEventListener('touchstart', onDown, { passive: true });
      window.addEventListener('pointermove', onMove, { passive: true });
      window.addEventListener('touchmove', onMove, { passive: true });
      window.addEventListener('pointerup', onUp);
      window.addEventListener('touchend', onUp);
    }

    function initAudio(root) {
      root.setAttribute('data-byob-pp-audio-muted', '1');
      function noop() {}

      return {
        onAdd:        noop,
        onRemove:     noop,
        onTierCross:  noop,
        onGiftUnlock: noop
      };
    }

    function haptic(ms) {
      if (prefersReducedMotion()) return;
      if (!navigator.vibrate) return;
      try { navigator.vibrate(ms || 8); }
      catch (e) {}
    }

    var roots = document.querySelectorAll('section.based-byob-pp[data-section-id]');
    roots.forEach(initRoot);

    function initRoot(root) {
      if (root.dataset.byobPpInit === '1') return;
      root.dataset.byobPpInit = '1';

      // bbw skin: the MOBILE bundle container (Figma 1676:2216) shows the bare
      // price right-aligned and writes rewards in words; the desktop panel
      // keeps the classic " - $x" suffix and stacked reward shorts.
      var bbwSkin = root.classList.contains('based-byob-pp--bbw');
      var mobileTotalSep = bbwSkin ? '' : ' - ';

      var tierEls = Array.prototype.slice.call(root.querySelectorAll('[data-tier-count]'));
      var tiers = tierEls.map(function (s) {
        // A discount typed outside 0-100 in the admin would drive a negative
        // total (or a free order), so the model clamps before anything reads it.
        var pct = parseInt(s.getAttribute('data-tier-pct'), 10);
        if (!isFinite(pct)) pct = 0;
        return {
          count: parseInt(s.getAttribute('data-tier-count'), 10),
          pct: Math.max(0, Math.min(100, pct))
        };
      }).sort(function (a, b) { return a.count - b.count; });
      tiers = normalizeTiers(tiers);

      // Gifts: [{key, trigger, id, valueCents, name, short, featured?}] — any
      // number of rewards, each unlocking at its own item count; several can
      // share one count. Parsed from the JSON node the section renders inside
      // the gift strip. (`side` is the pre-v2 name for `key`.)
      var giftEl = root.querySelector('[data-byob-gift]');
      var gifts = [];
      if (giftEl) {
        var giftsNode = giftEl.querySelector('[data-byob-gifts]');
        if (giftsNode) {
          try {
            gifts = (JSON.parse(giftsNode.textContent) || []).filter(function (g) {
              // Named placeholders intentionally stay in the presentation model
              // with id 0. They can unlock visually, but buildCartPayload never
              // sends them to Shopify.
              return g && g.trigger > 0;
            }).sort(function (a, b) { return a.trigger - b.trigger; });
          } catch (e) { gifts = []; }
        }
      }

      var state = {
        selections: [],
        activeTab: (function () {
          var firstTab = root.querySelector('[data-byob-tab]');
          return firstTab ? firstTab.getAttribute('data-byob-tab') : 'all';
        })(),
        tiers: tiers,
        gifts: gifts
      };
      var checkoutGuard = createCheckoutGuard();

      var els = {
        countNum: root.querySelector('[data-byob-count-num]'),
        countWrap: root.querySelector('.based-byob-pp__count'),
        progressMsg: root.querySelector('[data-byob-progress-msg]'),
        segments: Array.prototype.slice.call(root.querySelectorAll('[data-byob-seg]')),
        tierPills: Array.prototype.slice.call(root.querySelectorAll('[data-pill-count]')),
        gift: giftEl,
        slots: root.querySelector('[data-byob-slots]'),
        progress: root.querySelector('[data-byob-progress]'),
        progressBar: root.querySelector('[data-byob-progress-bar]'),
        checkoutLabel: root.querySelector('[data-byob-checkout-label]'),
        subtotal: root.querySelector('[data-byob-subtotal]'),
        savings: root.querySelector('[data-byob-savings]'),
        savingsRow: root.querySelector('[data-byob-savings-row]'),
        savingsLabel: root.querySelector('[data-byob-savings-label]'),
        total: root.querySelector('[data-byob-total]'),
        checkout: root.querySelector('[data-byob-checkout]'),
        checkoutTotal: root.querySelector('[data-byob-checkout-total]'),
        error: root.querySelector('[data-byob-error]'),
        mobileBar: root.querySelector('[data-byob-mobile-bar]'),
        mobileAvatars: root.querySelector('[data-byob-mobile-avatars]'),
        mobileSlots: Array.prototype.slice.call(root.querySelectorAll('[data-byob-mobile-slot]')),
        mobileTiers: Array.prototype.slice.call(root.querySelectorAll('[data-byob-mobile-tier]')),
        mobileGift: root.querySelector('[data-byob-mobile-gift]'),
        mobileCount: root.querySelector('[data-byob-mobile-count]'),
        mobileMsrp: root.querySelector('[data-byob-mobile-msrp]'),
        mobileTotal: root.querySelector('[data-byob-mobile-total]'),
        mobileDiscountChip: root.querySelector('[data-byob-mobile-discount-chip]'),
        mobileCheckout: root.querySelector('[data-byob-mobile-checkout]'),
        mobileCheckoutLabel: root.querySelector('[data-byob-mobile-checkout-label]'),
        mobileCheckoutTotal: root.querySelector('[data-byob-mobile-checkout-total]'),
        mobileProgress: root.querySelector('[data-byob-mobile-progress]'),
        mobileProgressBar: root.querySelector('[data-byob-mobile-progress-bar]'),
        mobileOpen: root.querySelector('[data-byob-mobile-open]'),
        drawer: root.querySelector('[data-byob-drawer]'),
        drawerSlots: root.querySelector('[data-byob-drawer-slots]'),
        drawerCount: root.querySelector('[data-byob-drawer-count]'),
        drawerProgress: root.querySelector('[data-byob-drawer-progress]'),
        drawerProgressBar: root.querySelector('[data-byob-drawer-progress-bar]'),
        drawerSubtotal: root.querySelector('[data-byob-drawer-subtotal]'),
        drawerSavings: root.querySelector('[data-byob-drawer-savings]'),
        drawerSavingsRow: root.querySelector('[data-byob-drawer-savings-row]'),
        drawerSavingsLabel: root.querySelector('[data-byob-drawer-savings-label]'),
        drawerTotal: root.querySelector('[data-byob-drawer-total]'),
        drawerDiscountChip: root.querySelector('[data-byob-drawer-discount-chip]'),
        drawerCheckout: root.querySelector('[data-byob-drawer-checkout]'),
        drawerCheckoutLabel: root.querySelector('[data-byob-drawer-checkout-label]'),
        drawerCheckoutTotal: root.querySelector('[data-byob-drawer-checkout-total]'),
        drawerError: root.querySelector('[data-byob-drawer-error]'),
        detail: root.querySelector('[data-byob-detail]'),
        detailLoader: root.querySelector('[data-byob-detail-loader]'),
        detailPanel: root.querySelector('.based-byob-pp__detail-panel'),
        detailImage: root.querySelector('[data-byob-detail-image]'),
        detailTitle: root.querySelector('[data-byob-detail-title]'),
        detailCategory: root.querySelector('[data-byob-detail-category]'),
        detailPrice: root.querySelector('[data-byob-detail-price]'),
        detailPriceFacts: root.querySelector('[data-byob-detail-price-facts]'),
        detailSummary: root.querySelector('[data-byob-detail-summary]'),
        detailScentRow: root.querySelector('[data-byob-detail-scent-row]'),
        detailScents: root.querySelector('[data-byob-detail-scents]'),
        detailOriginRow: root.querySelector('[data-byob-detail-origin-row]'),
        detailOrigin: root.querySelector('[data-byob-detail-origin]'),
        detailExtra: root.querySelector('[data-byob-detail-extra]'),
        detailExtraStatus: root.querySelector('[data-byob-detail-extra-status]'),
        detailExtraContent: root.querySelector('[data-byob-detail-extra-content]'),
        detailAdd: root.querySelector('[data-byob-detail-add]'),
        scentSheet: root.querySelector('[data-byob-scent-sheet]'),
        scentSheetTitle: root.querySelector('[data-byob-scent-sheet-title]'),
        scentOptions: root.querySelector('[data-byob-scent-options]')
      };
      var audioHooks = null;
      var mobileScrim = null;
      // Product-detail overlay temporarily disabled (info toggle hidden via CSS).
      // Flip to true (and unhide .based-byob-pp__card-info) to bring it back.
      var DETAIL_OVERLAY_ENABLED = false;
      var activeScentCard = null;
      var scentCloseTimer = null;
      var scentCloseToken = 0;
      var scentFocusReturn = null;
      var scentSheetOwnsScrollLock = false;
      var activeDetailCard = null;
      var lastFocusedBeforeDetail = null;
      var detailCloseTimer = null;
      var detailExtraCache = {};
      var detailExtraRequest = 0;

      // Symbol/code come from the section root (Liquid: cart.currency), so totals
      // match the shopper's market instead of hard-coding "$". Amounts embedded in
      // the page (variant prices, data-default-price) are already market-converted.
      var currencySymbol = root.getAttribute('data-byob-currency-symbol') || '$';
      var currencyCode = root.getAttribute('data-byob-currency-code') || 'USD';
      var moneyFmt = createMoneyFormatter(
        currencyCode,
        currencySymbol,
        document.documentElement && document.documentElement.lang
      );

      function setCountOdometer(el, newValue) {
        if (!el) return;
        var prev = el.textContent;
        if (String(prev) === String(newValue)) return;
        if (prefersReducedMotion() || !window.gsap) {
          el.textContent = newValue;
          return;
        }
        var span = document.createElement('span');
        span.style.display = 'inline-block';
        span.textContent = newValue;
        span.style.transform = 'translateY(100%)';
        span.style.opacity = '0';
        el.textContent = '';
        el.appendChild(span);
        window.gsap.to(span, { y: 0, opacity: 1, duration: 0.28, ease: 'power2.out' });
      }

      function setProgressMsg(el, newText) {
        if (!el) return;
        if (el.textContent === newText) return;
        if (prefersReducedMotion()) {
          el.textContent = newText;
          return;
        }
        el.style.transition = 'filter 180ms ease-out, opacity 180ms ease-out';
        el.style.filter = 'blur(4px)';
        el.style.opacity = '0';
        setTimeout(function () {
          el.textContent = newText;
          el.style.filter = 'blur(0)';
          el.style.opacity = '1';
        }, 180);
      }

      // Pure helpers, exported on window.BasedBYOBPremium for tests.
      // The shopper keeps the BEST discount they have unlocked, not whichever
      // tier happens to sit last in the list. Taking the last one means a
      // mis-ordered config (20% at 2 items, 10% at 4) would LOWER the discount
      // as a reward for adding an item. Equal percentages keep the higher
      // threshold so the "tier N unlocked" announcement names the one reached.
      function normalizeTiers(tiersArg) {
        var bestPct = 0;
        return (tiersArg || []).slice().sort(function (a, b) {
          return a.count - b.count;
        }).map(function (tier) {
          if (tier.pct > bestPct) bestPct = tier.pct;
          return { count: tier.count, pct: bestPct };
        });
      }
      function findActiveTier(count, tiersArg) {
        var match = null;
        (tiersArg || []).forEach(function (t) {
          if (t.count > count) return;
          if (!match || t.pct > match.pct || (t.pct === match.pct && t.count > match.count)) {
            match = t;
          }
        });
        return match;
      }
      function terminalRewardLabel(count, tiersArg, giftsArg) {
        var parts = [];
        var activeTier = findActiveTier(count, tiersArg || []);
        if (activeTier && activeTier.pct > 0) parts.push(activeTier.pct + '% off');
        var allGifts = giftPhrase((giftsArg || []).map(function (g) { return g.name; }), true);
        if (allGifts) parts.push(allGifts);
        return parts.join(' + ') || 'All rewards';
      }
      function firstRewardCount(tiersArg, giftsArg) {
        var first = 0;
        (tiersArg || []).forEach(function (t) {
          if (t.count > 0 && t.pct > 0 && (!first || t.count < first)) first = t.count;
        });
        (giftsArg || []).forEach(function (g) {
          if (g.trigger > 0 && (!first || g.trigger < first)) first = g.trigger;
        });
        return first || 1;
      }
      function lastRewardCountFor(tiersArg, giftsArg, fallback) {
        var last = 0;
        (tiersArg || []).forEach(function (t) {
          if (t.count > last && t.pct > 0) last = t.count;
        });
        (giftsArg || []).forEach(function (g) {
          if (g.trigger > last) last = g.trigger;
        });
        return last || fallback || 6;
      }
      // Gifts unlocked at an item count — each gift has its own trigger.
      function unlockedGifts(count, giftsArg) {
        return (giftsArg || []).filter(function (g) { return count >= g.trigger; });
      }
      function allGiftsUnlocked(count, giftsArg) {
        return !!(giftsArg && giftsArg.length) && unlockedGifts(count, giftsArg).length === giftsArg.length;
      }
      function computeTotals(selections, tiersArg, giftsArg) {
        var subtotalCents = selections.reduce(function (sum, s) {
          return sum + igResolvePriceCents(s.variantId, s.price);
        }, 0);
        var count = selections.length;
        var tier = findActiveTier(count, tiersArg);
        var pct = tier ? tier.pct : 0;
        var savingsCents = Math.round(subtotalCents * pct / 100);
        var totalCents = subtotalCents - savingsCents;
        // Unlocked free gifts enter both the subtotal and the savings (so
        // subtotal − savings = total stays true on screen) but never the payable
        // total — the free-product code zeroes their lines at checkout. The tier
        // discount itself is computed on the items only, not the gift value.
        // Dedupe by variant exactly like buildCartPayload: two rewards pointing
        // at one variant add a SINGLE cart line, so counting the value twice
        // would overstate both the subtotal and the savings on screen.
        var seenGiftValueIds = {};
        var giftValueCents = unlockedGifts(count, giftsArg).reduce(function (sum, g) {
          if (g.id) {
            if (seenGiftValueIds[g.id]) return sum;
            seenGiftValueIds[g.id] = true;
          }
          return sum + (g.valueCents || 0);
        }, 0);
        if (giftValueCents > 0) {
          subtotalCents += giftValueCents;
          savingsCents += giftValueCents;
        }
        return { subtotalCents: subtotalCents, savingsCents: savingsCents, totalCents: totalCents, giftValueCents: giftValueCents, pct: pct, count: count };
      }
      function buildCartPayload(selections, giftsArg) {
        var items = selections.map(function (s, i) {
          return { id: s.variantId, quantity: 1, properties: { _byob_item: 'true', _byob_slot: String(i) } };
        });
        // Two rewards pointing at one variant must not double the gift line —
        // One gift per variant; the 'gift' marker separates gifts from paid set items in server rules.
        var seenGiftIds = {};
        unlockedGifts(selections.length, giftsArg).forEach(function (g) {
          // Placeholder rewards (id 0) render but have nothing to add.
          if (!g.id) return;
          if (seenGiftIds[g.id]) return;
          seenGiftIds[g.id] = true;
          items.push({ id: g.id, quantity: 1, properties: { _byob_item: 'gift', _byob_gift: 'true' } });
        });
        return items;
      }
      function storefrontAccessToken() {
        return (root.getAttribute('data-byob-storefront-token') || '').trim();
      }
      function storefrontApiVersion() {
        var version = (root.getAttribute('data-byob-storefront-api-version') || '2026-04').trim();
        return /^(\d{4}-\d{2}|unstable)$/.test(version) ? version : '2026-04';
      }
      function storefrontEndpoint() {
        return '/api/' + storefrontApiVersion() + '/graphql.json';
      }
      function productVariantGid(id) {
        var raw = String(id || '').trim();
        if (raw.indexOf('gid://shopify/ProductVariant/') === 0) return raw;
        return 'gid://shopify/ProductVariant/' + raw;
      }
      function cartLineAttributes(properties) {
        var attrs = [];
        for (var key in properties) {
          if (Object.prototype.hasOwnProperty.call(properties, key)) {
            attrs.push({ key: key, value: String(properties[key]) });
          }
        }
        return attrs;
      }
      function cartCreateLines(items) {
        return items.map(function (item) {
          return {
            merchandiseId: productVariantGid(item.id),
            quantity: item.quantity || 1,
            attributes: cartLineAttributes(item.properties || {})
          };
        });
      }
      function payloadQuantity(items) {
        return items.reduce(function (sum, item) {
          return sum + (item.quantity || 1);
        }, 0);
      }
      function verifyOfferCodes(discounts, codes, items) {
        var paidQuantity = items.reduce(function (sum, item) {
          return sum + (item.properties && item.properties._byob_gift === 'true' ? 0 : Number(item.quantity));
        }, 0);
        var earnsGifts = items.some(function (item) {
          return item.properties && item.properties._byob_gift === 'true';
        });
        codes.forEach(function (code) {
          if (code.toUpperCase() === 'BUILDYOURSET' && paidQuantity < 2) return;
          if (code.toUpperCase() === 'BYOBFREEGIFTS' && !earnsGifts) return;
          if (!Array.isArray(discounts) || !discounts.some(function (discount) {
            return String(discount.code || '').toUpperCase() === code.toUpperCase() && discount.applicable === true;
          })) throw new Error('Your set discount or free gifts could not be confirmed. Please try again.');
        });
      }
      function hasAttribute(attrs, key, value) {
        if (!Array.isArray(attrs)) return false;
        return attrs.some(function (attr) {
          return attr && attr.key === key && String(attr.value) === String(value);
        });
      }
      function createStorefrontCart(items, codes, initiatedAt) {
        var token = storefrontAccessToken();
        if (!token) return Promise.reject(new Error('Storefront API token is not configured.'));

        var mutation = [
          'mutation BasedByobCartCreate($input: CartInput!) {',
          '  cartCreate(input: $input) {',
          '    cart {',
          '      id',
          '      checkoutUrl',
          '      totalQuantity',
          '      attributes { key value }',
          '      discountCodes { code applicable }',
          '    }',
          '    userErrors { field message code }',
          '    warnings { code message target }',
          '  }',
          '}'
        ].join('\n');
        var input = {
          lines: cartCreateLines(items),
          attributes: [
            { key: 'byob_session', value: 'true' },
            { key: 'byob_initiated_at', value: initiatedAt }
          ]
        };
        if (codes.length) input.discountCodes = codes;

        return fetch(storefrontEndpoint(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({ query: mutation, variables: { input: input } })
        }).then(function (response) {
          return response.json().catch(function () { return null; }).then(function (json) {
            if (!response.ok) {
              throw new Error('Storefront cart create failed (' + response.status + ').');
            }
            if (!json) throw new Error('Storefront cart create returned an empty response.');
            if (json.errors && json.errors.length) {
              throw new Error(json.errors.map(function (err) { return err.message; }).join(' '));
            }
            var payload = json.data && json.data.cartCreate;
            var userErrors = payload && payload.userErrors ? payload.userErrors : [];
            if (userErrors.length) {
              throw new Error(userErrors.map(function (err) { return err.message; }).join(' '));
            }
            if (payload && payload.warnings && payload.warnings.length && window.console && typeof window.console.warn === 'function') {
              window.console.warn('[BYOB] Storefront cartCreate warnings:', payload.warnings);
            }
            var cart = payload && payload.cart;
            if (!cart || !cart.checkoutUrl) throw new Error('Storefront cart create did not return a checkout URL.');
            if (!hasAttribute(cart.attributes, 'byob_session', 'true')) {
              throw new Error('Storefront cart create did not preserve BYOB cart attributes.');
            }
            if (cart.totalQuantity !== payloadQuantity(items)) {
              throw new Error('Storefront cart create returned an unexpected item count.');
            }
            verifyOfferCodes(cart.discountCodes, codes, items);
            return cart.checkoutUrl;
          });
        });
      }
      function getDiscountCodes() {
        var codesAttr = (root.getAttribute('data-byob-discount-codes') || '').trim();
        return codesAttr ? codesAttr.split(',').map(function (c) { return c.trim(); }).filter(Boolean) : [];
      }
      function checkoutDestination(codes) {
        if (!codes.length) return '/checkout';
        var params = new URLSearchParams();
        params.append('discount', codes.join(','));
        return '/checkout?' + params.toString();
      }
      function cardAllowsVariantImageSwap(lockedValue) {
        return String(lockedValue || '').toLowerCase() !== 'true';
      }
      function selectionImageForVariant(cardImage, variantImage, lockedValue, variantCardImage) {
        if (variantCardImage) return variantCardImage;
        if (cardImage && !cardAllowsVariantImageSwap(lockedValue)) return cardImage;
        return variantImage || cardImage || '';
      }

      window.BasedBYOBPremium = window.BasedBYOBPremium || {};
      window.BasedBYOBPremium.findActiveTier = findActiveTier;
      window.BasedBYOBPremium.computeTotals = computeTotals;
      window.BasedBYOBPremium.unlockedGifts = unlockedGifts;
      window.BasedBYOBPremium.buildCartPayload = buildCartPayload;
      window.BasedBYOBPremium.giftPhrase = giftPhrase;
      window.BasedBYOBPremium.terminalRewardLabel = terminalRewardLabel;
      window.BasedBYOBPremium.normalizeTiers = normalizeTiers;
      window.BasedBYOBPremium.firstRewardCount = firstRewardCount;
      window.BasedBYOBPremium.lastRewardCountFor = lastRewardCountFor;
      window.BasedBYOBPremium.cardAllowsVariantImageSwap = cardAllowsVariantImageSwap;
      window.BasedBYOBPremium.selectionImageForVariant = selectionImageForVariant;
      window.BasedBYOBPremium.setCardImageForVariant = setCardImageForVariant;

      // Price/app updates can replace a card node while the mobile scent sheet is
      // open. Resolve the current node by product identity before applying a pick.
      function resolveScentCard(rootEl, activeCard, productId, productHandle) {
        if (activeCard && rootEl.contains(activeCard)) return activeCard;
        var cards = Array.prototype.slice.call(rootEl.querySelectorAll('[data-byob-card]'));
        var resolved = null;
        cards.some(function (card) {
          var idMatches = productId && String(card.getAttribute('data-product-id')) === String(productId);
          var handleMatches = !productId && productHandle && card.getAttribute('data-product-handle') === productHandle;
          if (!idMatches && !handleMatches) return false;
          resolved = card;
          return true;
        });
        return resolved;
      }

      window.BasedBYOBPremium.resolveScentCard = resolveScentCard;

      function renderAll() {
        renderCards();
        renderTabs();
        renderLadder();
        renderPanel();
        renderMobileBar();
      }

      function syncAllCardPriceBindings() {
        root.querySelectorAll('[data-byob-card]').forEach(function (card) {
          var binding = card.querySelector('.based-byob-pp__card-price, .bbw-pcard__price');
          var variantId = binding && binding.getAttribute('data-variant-id');
          if (!variantId) variantId = card.getAttribute('data-default-variant');
          var variant = parseVariants(card).find(function (candidate) {
            return String(candidate.id) === String(variantId);
          });
          if (variant) syncCardPriceBinding(card, variant, moneyFmt);
        });
      }

      // Gold glitter celebration — disabled (removed on all breakpoints).
      function burstGlitter() {
        return;
        // eslint-disable-next-line no-unreachable
        if (prefersReducedMotion()) return;
        var layer = root.querySelector('[data-byob-glitter]');
        if (!layer) {
          layer = document.createElement('div');
          layer.className = 'based-byob-pp__glitter';
          layer.setAttribute('data-byob-glitter', '');
          layer.setAttribute('aria-hidden', 'true');
          root.appendChild(layer);
        }
        while (layer.firstChild) layer.removeChild(layer.firstChild);
        var count = 90;
        for (var i = 0; i < count; i++) {
          var bit = document.createElement('span');
          bit.className = 'based-byob-pp__glitter-bit';
          var size = 4 + Math.random() * 6;
          bit.style.left = (Math.random() * 100) + '%';
          bit.style.width = size + 'px';
          bit.style.height = (size * (0.4 + Math.random() * 0.8)) + 'px';
          bit.style.animationDelay = (Math.random() * 700) + 'ms';
          bit.style.animationDuration = (1700 + Math.random() * 1600) + 'ms';
          bit.style.setProperty('--rot', Math.round(Math.random() * 360) + 'deg');
          bit.style.setProperty('--drift', (Math.round((Math.random() - 0.5) * 160)) + 'px');
          layer.appendChild(bit);
        }
        if (burstGlitter._t) clearTimeout(burstGlitter._t);
        burstGlitter._t = setTimeout(function () {
          while (layer.firstChild) layer.removeChild(layer.firstChild);
        }, 3600);
      }

      // Custom product order for the "All" tab only (Skin Elixir → Hair Care → Hair Styling
      // straight → curly → Body → Skin). Other tabs keep the collection order
      // (restored via data-byob-orig-order). In every tab, sold-out cards move
      // below purchasable cards while preserving the tab's relative order.
      var ALL_TAB_ORDER = [
        'skin-elixir',
        'shampoo', 'conditioner', 'hair-elixir',
        'texturizing-powder', 'hair-clay', 'sea-salt-spray', 'pomade',
        'leave-in-conditioner', 'curl-cream', 'curl-mousse', 'curl-gel', 'curl-refresh-spray',
        'body-lotion', 'bodywash', 'deodorant',
        'under-eye-elixir', 'skin-revival-spray'
      ];
      var allTabRank = {};
      ALL_TAB_ORDER.forEach(function (h, i) { allTabRank[h] = i; });
      var lastOrderedTab = null;

      function applyCardOrder() {
        var grid = root.querySelector('[data-byob-grid]');
        if (!grid || state.activeTab === lastOrderedTab) return;
        lastOrderedTab = state.activeTab;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-byob-card]'));
        if (!cards.length) return;
        var useAll = state.activeTab === 'all';
        function origOrder(el) { return parseInt(el.getAttribute('data-byob-orig-order'), 10) || 0; }
        function isSoldOut(el) {
          return el.getAttribute('data-purchase-state') === 'out_of_stock' ||
            el.classList.contains('based-byob-pp__card--oos');
        }
        function activeTabBucket(el) {
          if (useAll) return 0;
          var category = el.getAttribute('data-category') || '';
          return category.split(' ').indexOf(state.activeTab) !== -1 ? 0 : 1;
        }
        function productOrder(el) {
          if (!useAll) return origOrder(el);
          var handle = el.getAttribute('data-product-handle');
          return (handle in allTabRank) ? allTabRank[handle] : (1000 + origOrder(el));
        }
        cards.sort(function (a, b) {
          var tabA = activeTabBucket(a);
          var tabB = activeTabBucket(b);
          if (tabA !== tabB) return tabA - tabB;

          var oosA = isSoldOut(a) ? 1 : 0;
          var oosB = isSoldOut(b) ? 1 : 0;
          if (oosA !== oosB) return oosA - oosB;

          // Listed products sort by their explicit rank; anything unlisted falls
          // after them, keeping its original relative order.
          return productOrder(a) - productOrder(b);
        });
        cards.forEach(function (c) { grid.appendChild(c); });
      }

      function renderCards() {
        applyCardOrder();
        var cards = root.querySelectorAll('[data-byob-card]');
        var bundleFull = state.selections.length >= setCapacity();
        cards.forEach(function (card) {
          var variants = parseVariants(card);
          var pickedScent = card.getAttribute('data-picked-scent') || '';
          var activeVariant = findCardVariant(variants, pickedScent);
          var qty = activeVariant
            ? countSelectionsForVariant(state.selections, activeVariant.id)
            : 0;
          var selected = qty > 0;
          card.setAttribute('data-selected', selected ? '1' : '0');
          if (selected) {
            if (!card.dataset.ignitePending && !card.dataset.igniteDone) {
              card.dataset.ignitePending = '1';
              setTimeout(function () {
                card.setAttribute('data-ignite-done', '1');
                delete card.dataset.ignitePending;
              }, 500);
            }
          } else {
            delete card.dataset.ignitePending;
            card.removeAttribute('data-ignite-done');
          }

          // Button state: quantity stepper when in the bundle, completed (locked)
          // when the bundle is full and this product isn't in it, else default.
          var addBtn = card.querySelector('[data-byob-add]');
          var incBtn = card.querySelector('[data-byob-qty-inc]');
          var decBtn = card.querySelector('[data-byob-qty-dec]');
          if (!card.classList.contains('based-byob-pp__card--oos')) {
            card.setAttribute('data-card-state', selected ? 'quantity' : (bundleFull ? 'completed' : 'default'));
            var qtyEl = card.querySelector('[data-byob-qty]');
            if (qtyEl) qtyEl.textContent = qty;
            if (incBtn) incBtn.disabled = bundleFull;
          }

          var productTitle = card.getAttribute('data-product-title') || 'product';
          var scentSuffix = activeVariant && activeVariant.scent ? ' in ' + activeVariant.scent : '';
          if (addBtn) addBtn.setAttribute('aria-label', 'Add ' + productTitle + scentSuffix + ' to bundle');
          if (incBtn) incBtn.setAttribute('aria-label', 'Add one ' + productTitle + scentSuffix);
          if (decBtn) decBtn.setAttribute('aria-label', 'Remove one ' + productTitle + scentSuffix);

          var category = card.getAttribute('data-category') || '';
          var cats = category.split(' ');
          var visible = state.activeTab === 'all' || cats.indexOf(state.activeTab) !== -1;
          card.style.display = visible ? '' : 'none';
          var picked = card.getAttribute('data-picked-scent');
          card.querySelectorAll('[data-scent]').forEach(function (dot) {
            dot.setAttribute('aria-pressed', dot.getAttribute('data-scent') === picked ? 'true' : 'false');
          });
        });
      }

      function renderTabs() {
        root.querySelectorAll('[data-byob-tab]').forEach(function (tab) {
          var on = tab.getAttribute('data-byob-tab') === state.activeTab;
          tab.classList.toggle('based-byob-pp__tab--active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          // Roving tabindex: only the active tab is in the tab order; arrow keys move focus.
          tab.setAttribute('tabindex', on ? '0' : '-1');
        });
        var indicator = root.querySelector('[data-byob-tab-indicator]');
        if (indicator) {
          var activeTab = root.querySelector('.based-byob-pp__tab--active');
          if (activeTab) {
            var rect = activeTab.getBoundingClientRect();
            var parentRect = activeTab.parentElement.getBoundingClientRect();
            indicator.style.width = rect.width + 'px';
            indicator.style.transform = 'translateX(' + (rect.left - parentRect.left) + 'px)';
          }
        }
      }

      var prevCount = 0;
      var prevActiveTierCount = 0;
      function renderLadder() {
        var totals = computeTotals(state.selections, state.tiers, state.gifts);
        var activeTier = findActiveTier(totals.count, state.tiers);
        var activeTierCount = activeTier ? activeTier.count : 0;
        var crossedNewTier = activeTierCount > 0 && activeTierCount !== prevActiveTierCount && totals.count > prevCount;

        setCountOdometer(els.countNum, totals.count);
        if (els.countWrap) els.countWrap.setAttribute('data-active-tier', activeTier ? '1' : '0');

        // Segments fill 1..count and quietly mark reward thresholds (tiers + gifts).
        var tierCounts = state.tiers.map(function (t) { return t.count; });
        state.gifts.forEach(function (g) {
          if (tierCounts.indexOf(g.trigger) === -1) tierCounts.push(g.trigger);
        });
        els.segments.forEach(function (seg) {
          var n = parseInt(seg.getAttribute('data-byob-seg'), 10);
          var nowFilled = n <= totals.count;
          var wasFilled = n <= prevCount;
          seg.classList.toggle('based-byob-pp__seg--filled', nowFilled);
          seg.classList.remove('based-byob-pp__seg--just-unlocked');
          if (nowFilled && !wasFilled && tierCounts.indexOf(n) !== -1) {
            void seg.offsetWidth;
            seg.classList.add('based-byob-pp__seg--just-unlocked');
            var tierPlayedAttr = 'data-byob-pp-tier-played-' + n;
            if (audioHooks && !root.hasAttribute(tierPlayedAttr)) {
              root.setAttribute(tierPlayedAttr, '1');
              audioHooks.onTierCross();
              haptic(12);
            }
          }
        });

        var liveEl = root.querySelector('[data-byob-pp-live]');
        if (liveEl && crossedNewTier && activeTier) {
          liveEl.textContent = 'Tier ' + activeTier.count + ' unlocked, ' + activeTier.pct + ' percent off.';
        }

        // Reward pills (tiers + gifts): hit + current. "Current" is the highest
        // pill already reached, whatever kind of reward it carries.
        var maxHitPill = 0;
        els.tierPills.forEach(function (pill) {
          var c = parseInt(pill.getAttribute('data-pill-count'), 10);
          if (totals.count >= c && c > maxHitPill) maxHitPill = c;
        });
        els.tierPills.forEach(function (pill) {
          var c = parseInt(pill.getAttribute('data-pill-count'), 10);
          if (maxHitPill > 0 && c === maxHitPill) {
            pill.setAttribute('data-active', 'current');
          } else if (totals.count >= c) {
            pill.setAttribute('data-active', 'hit');
          } else {
            pill.removeAttribute('data-active');
          }
        });

        // Progress message above bar — next reward of any kind (tier or gift).
        if (els.progressMsg) {
          var nxt = nextRewardAfter(totals.count);
          if (totals.count === 0 && nxt) {
            setProgressMsg(els.progressMsg, 'Add ' + nxt.count + ' ' + (nxt.count === 1 ? 'item' : 'items') + ' to unlock ' + nxt.label);
          } else if (nxt) {
            setProgressMsg(els.progressMsg, (nxt.count - totals.count) + ' more for ' + nxt.label);
          } else if (state.gifts.length) {
            setProgressMsg(els.progressMsg, 'All rewards unlocked. Free gifts added at checkout.');
          } else {
            setProgressMsg(els.progressMsg, 'Top tier unlocked.');
          }
        }

        // Celebrate when every reward (top tier + all gifts) is unlocked.
        var crossedTop = totals.count >= lastRewardCount();
        if (crossedTop && root.getAttribute('data-byob-pp-celebrated') !== '1') {
          root.setAttribute('data-byob-pp-celebrated', '1');
          burstGlitter();
        } else if (!crossedTop) {
          root.removeAttribute('data-byob-pp-celebrated');
        }

        // Gift strip: fully lit once every gift is unlocked; the unlock sound
        // plays each time a NEW gift crosses its trigger.
        if (els.gift && state.gifts.length) {
          var unlockedCount = unlockedGifts(totals.count, state.gifts).length;
          els.gift.classList.toggle('based-byob-pp__gift--unlocked', unlockedCount === state.gifts.length);
          var prevUnlocked = parseInt(root.getAttribute('data-byob-pp-gifts-played') || '0', 10);
          if (unlockedCount > prevUnlocked) {
            root.setAttribute('data-byob-pp-gifts-played', String(unlockedCount));
            if (audioHooks) audioHooks.onGiftUnlock();
            haptic(14);
          } else if (unlockedCount < prevUnlocked) {
            root.setAttribute('data-byob-pp-gifts-played', String(unlockedCount));
          }
        }

        prevActiveTierCount = activeTierCount;
        prevCount = totals.count;
      }

      // Highest item count that still unlocks something (top tier or last gift).
      function lastRewardCount() {
        return lastRewardCountFor(state.tiers, state.gifts, 6);
      }

      // How many items a set can hold: the rendered slot grid (e.g. 6), which can
      // exceed the last reward count so shoppers keep adding past the final unlock.
      function setCapacity() {
        return Math.max(slotGridSize, lastRewardCount());
      }

      function renderPanel() {
        var totals = computeTotals(state.selections, state.tiers, state.gifts);
        // Drives the un-blur of the free-gift cards: each card lights up at its
        // own trigger; the root attribute flips once ALL gifts are unlocked.
        if (state.gifts.length) {
          root.setAttribute('data-gifts-unlocked', allGiftsUnlocked(totals.count, state.gifts) ? '1' : '0');
          syncGiftCardStates(totals.count);
        }
        var blurred = state.selections.length === 0 ? '1' : '0';
        // Include the mobile bar's totals — it's reparented to <body>, so it's no
        // longer found by root.querySelectorAll.
        var totalsEls = Array.prototype.slice.call(root.querySelectorAll('.based-byob-pp__totals'));
        if (els.mobileBar) {
          totalsEls = totalsEls.concat(Array.prototype.slice.call(els.mobileBar.querySelectorAll('.based-byob-pp__totals')));
        }
        totalsEls.forEach(function (t) {
          t.setAttribute('data-blurred', blurred);
        });
        renderSlotsInto(els.slots, totals, 'grid');
        renderTotalsInto({
          progress: els.progress, subtotal: els.subtotal, savings: els.savings,
          savingsRow: els.savingsRow, savingsLabel: els.savingsLabel, total: els.total,
          checkout: els.checkout, checkoutTotal: els.checkoutTotal
        }, totals);
        updateDesktopPanel(totals);

        var firstUnlockCount = firstRewardCount(state.tiers, state.gifts);
        var crossed = state.selections.length >= firstUnlockCount;
        var alreadyIgnited = root.getAttribute('data-byob-pp-tier-reached') === '1';
        if (crossed && !alreadyIgnited && els.checkout) {
          root.setAttribute('data-byob-pp-tier-reached', '1');
        }

        renderSlotsInto(els.drawerSlots, totals, 'grid');
        renderTotalsInto({
          progress: els.drawerProgress, subtotal: els.drawerSubtotal, savings: els.drawerSavings,
          savingsRow: els.drawerSavingsRow, savingsLabel: els.drawerSavingsLabel, total: els.drawerTotal,
          discountChip: els.drawerDiscountChip,
          checkout: els.drawerCheckout, checkoutTotal: els.drawerCheckoutTotal
        }, totals);
        if (els.drawerCount) els.drawerCount.textContent = totals.count;
        setProgressUI(els.drawerProgress, els.drawerProgressBar, totals);
        setCtaLabel(els.drawerCheckoutLabel, totals, 'drawer');
      }

      // Per-gift unlock state on the panel gift cards + mobile tiles. The Liquid
      // renders card[data-byob-gift-card="<key>"] and tile[data-byob-gift-tile];
      // gifts carry the matching `key` (`side` on pre-v2 markup). `data-near`
      // marks a reward exactly one item away — the "nearly unlocked" state.
      function syncGiftCardStates(count) {
        // The nearly-unlocked highlight is a v2 treatment: structured offers
        // only, so the legacy live page keeps its exact pre-v2 presentation.
        var structMode = root.hasAttribute('data-byob-struct');
        state.gifts.forEach(function (g) {
          var key = g.key || g.side;
          if (!key) return;
          var on = count >= g.trigger ? '1' : '0';
          var near = structMode && count < g.trigger && g.trigger - count === 1 ? '1' : '0';
          // Cards AND tiles need both scopes: initMobileBarPortal moves the bar
          // to document.body, so anything inside it is outside `root`.
          var scopes = [root];
          if (els.mobileBar && !root.contains(els.mobileBar)) scopes.push(els.mobileBar);
          scopes.forEach(function (scope) {
            var nodes = scope.querySelectorAll('[data-byob-gift-card="' + key + '"], [data-byob-gift-tile="' + key + '"]');
            Array.prototype.forEach.call(nodes, function (el) {
              el.setAttribute('data-unlocked', on);
              el.setAttribute('data-near', near);
            });
          });
          // The cards above are aria-hidden, so this list is the only place a
          // screen reader learns the gift names and whether they are unlocked.
          // It lives in the section root, never in the portaled bar.
          var srItem = root.querySelector('[data-byob-gift-sr-item="' + key + '"]');
          if (srItem) {
            srItem.textContent = on === '1'
              ? g.name + ': unlocked.'
              : g.name + ': locked, unlocks at ' + g.trigger + ' item' + (g.trigger === 1 ? '' : 's') + '.';
          }
        });
      }

      // The visible slot-grid size comes from the Liquid render (--byob-top-tier,
      // e.g. 6) — it can exceed the last reward count so the set keeps growing
      // past the final unlock.
      var slotGridSize = (function () {
        var v = parseInt((root.style.getPropertyValue('--byob-top-tier') || '').trim(), 10);
        if (v > 0) return v;
        return els.slots && els.slots.children.length ? els.slots.children.length : 6;
      })();

      function renderSlotsInto(container, totals, mode) {
        if (!container) return;
        var grid = mode === 'grid';
        // bbw writes slot rewards in words ("20% Off + Free Gifts") on both the
        // desktop panel and the mobile container; classic keeps stacked shorts.
        var useWords = bbwSkin;
        var slotCount = Math.max(slotGridSize, lastRewardCount(), state.selections.length);
        var specs = [];
        for (var i = 0; i < slotCount; i++) {
          var sel = state.selections[i];
          if (sel) {
            var itemKey = slotRenderKey(sel, i);
            specs.push({
              key: itemKey,
              html: grid ? gridSlotHTML(sel, i, itemKey) : slotRowHTML(sel, i, itemKey)
            });
          } else {
            specs.push({
              key: 'empty:' + i,
              html: grid ? gridEmptyHTML(i, useWords) : '<div class="based-byob-pp__slot based-byob-pp__slot--empty" data-byob-slot data-byob-slot-index="' + i + '" data-byob-render-key="empty:' + i + '">Empty slot ' + (i + 1) + '</div>'
            });
          }
        }
        // The desktop grid is a fixed 3-col layout; the gift teaser stays in the
        // header strip, so only the drawer (list mode) appends unlocked gift slots.
        if (!grid) {
          unlockedGifts(totals.count, state.gifts).forEach(function (g) {
            var giftKey = 'gift:' + (g.key || g.side || g.name);
            specs.push({
              key: giftKey,
              html: '<div class="based-byob-pp__slot based-byob-pp__slot--gift" data-byob-render-key="' + escapeAttr(giftKey) + '">' + escapeHTML('Free ' + g.name) + '</div>'
            });
          });
        }
        specs.forEach(function (spec, index) {
          var child = container.children[index];
          if (child && child.getAttribute('data-byob-render-key') === spec.key) return;
          var node = htmlToElement(spec.html);
          if (child) container.replaceChild(node, child);
          else container.appendChild(node);
        });
        while (container.children.length > specs.length) {
          container.removeChild(container.lastElementChild);
        }
      }

      function htmlToElement(html) {
        var template = document.createElement('template');
        template.innerHTML = html.trim();
        return template.content.firstElementChild;
      }

      function slotRenderKey(sel, i) {
        return [
          'item',
          i,
          sel.variantId || '',
          sel.productId || '',
          sel.image || '',
          sel.title || '',
          sel.scentValue || ''
        ].join(':');
      }

      function slotRowHTML(sel, i, renderKey) {
        var scentMarkup = '';
        if (sel.scents && sel.scents.length > 1) {
          scentMarkup = '<select class="based-byob-pp__slot-scent" data-byob-scent-edit="' + i + '">' +
            sel.scents.map(function (sc) {
              return '<option value="' + escapeAttr(sc.scent) + '" data-variant-id="' + sc.id + '" data-variant-image="' + escapeAttr(sc.image || sc.imageLarge || '') + '" data-variant-card-image="' + escapeAttr(sc.cardImage || sc.cardImageLarge || '') + '"' + (sc.scent === sel.scentValue ? ' selected' : '') + (sc.available ? '' : ' disabled') + '>' + escapeHTML(sc.scent) + '</option>';
            }).join('') + '</select>';
        } else if (sel.scentValue) {
          scentMarkup = '<span class="based-byob-pp__slot-scent">' + escapeHTML(sel.scentValue) + '</span>';
        }
        return '<div class="based-byob-pp__slot" data-byob-slot data-byob-slot-index="' + i + '" data-byob-render-key="' + escapeAttr(renderKey) + '">' +
          '<img class="based-byob-pp__slot-img" src="' + escapeAttr(sel.image || '') + '" alt="" loading="eager" decoding="async">' +
          '<div class="based-byob-pp__slot-info">' +
            '<p class="based-byob-pp__slot-title">' + escapeHTML(sel.title) + '</p>' + scentMarkup +
          '</div>' +
          '<button type="button" class="based-byob-pp__slot-remove" data-byob-remove="' + i + '" aria-label="Remove">×</button>' +
        '</div>';
      }

      // Desktop grid tiles (panel only). Mobile drawer keeps slotRowHTML above.
      // MUST mirror the Liquid slot-reward markup (initial render vs re-render).
      // useWords: the bbw mobile bundle container writes rewards in words
      // ("10% Off + Free Gifts"); everything else keeps the stacked shorts.
      function slotRewardHTML(pos, useWords) {
        var pct = null;
        for (var i = 0; i < state.tiers.length; i++) {
          if (state.tiers[i].count === pos) pct = state.tiers[i].pct;
        }
        var giftsAt = state.gifts.filter(function (g) { return g.trigger === pos; });
        if (useWords) {
          var giftWord = giftsAt.length > 1 ? 'Free Gifts' : 'Free Gift';
          if (pct !== null && giftsAt.length) {
            return '<span class="based-byob-pp__slot-reward">' + pct + '% Off + ' + giftWord + '</span>';
          }
          if (giftsAt.length) {
            return '<span class="based-byob-pp__slot-reward">' + giftWord + '</span>';
          }
          if (pct !== null) {
            return '<span class="based-byob-pp__slot-reward">' + pct + '% Off</span>';
          }
          return '';
        }
        var shorts = giftsAt.map(function (g) { return g.short || g.name; }).join('+');
        if (pct !== null && shorts) {
          return '<span class="based-byob-pp__slot-reward">' + pct + '%<br>+' + escapeHTML(shorts) + '</span>';
        }
        if (shorts) {
          return '<span class="based-byob-pp__slot-reward">FREE<br>' + escapeHTML(shorts) + '</span>';
        }
        if (pct !== null) {
          return '<span class="based-byob-pp__slot-reward">' + pct + '%<br>OFF</span>';
        }
        return '';
      }

      function gridEmptyHTML(i, useWords) {
        return '<div class="based-byob-pp__slot based-byob-pp__slot--empty" data-byob-slot data-byob-slot-index="' + i + '" data-byob-render-key="empty:' + i + '">' +
          '<span class="based-byob-pp__slot-num">' + (i + 1) + '</span>' +
          slotRewardHTML(i + 1, useWords) +
          '<span class="based-byob-pp__slot-hint">Select Product</span>' +
        '</div>';
      }

      function gridSlotHTML(sel, i, renderKey) {
        var scentMarkup = sel.scentValue ? '<span class="based-byob-pp__slot-scent">' + escapeHTML(sel.scentValue) + '</span>' : '';
        return '<div class="based-byob-pp__slot based-byob-pp__slot--filled" data-byob-slot data-byob-slot-index="' + i + '" data-byob-render-key="' + escapeAttr(renderKey) + '">' +
          '<button type="button" class="based-byob-pp__slot-num based-byob-pp__slot-remove" data-byob-remove="' + i + '" aria-label="Remove ' + escapeAttr(sel.title || 'item') + '">×</button>' +
          '<img class="based-byob-pp__slot-img" src="' + escapeAttr(sel.image || '') + '" alt="" loading="eager" decoding="async">' +
          '<span class="based-byob-pp__slot-title">' + escapeHTML(sel.title || '') + '</span>' +
          scentMarkup +
        '</div>';
      }

      // Shared "You're N away from free X" progress text + bar fill. Used by the
      // desktop panel, the mobile bar, and the mobile drawer.
      // Next *meaningful* reward ahead of the current count: a tier that actually
      // raises the discount, or a gift that hasn't unlocked yet — whichever comes
      // first. Skips same-percentage tiers so we never say "unlock 20% off" at 20%.
      // Gift half of a reward label. Classic names every gift ("Free Wooden Comb
      // + Free Mini Skin Revival Spray"); bbw collapses 2+ into a count so the
      // line stays one compact row ("2 Free Gifts" / "All 3 Free Gifts").
      // `more` is set when the shopper has already unlocked a gift, so the count
      // reads as ADDITIONAL gifts ("2 more FREE gifts") rather than the whole
      // set — at 3 items the bag is already theirs and the 4th adds two others.
      function giftPhrase(names, all, more) {
        if (!names.length) return '';
        if (bbwSkin && names.length > 1) {
          if (all) return 'All ' + names.length + ' Free Gifts';
          return names.length + (more ? ' more FREE gifts' : ' FREE gifts');
        }
        return names.map(function (n) { return 'Free ' + n; }).join(' + ');
      }

      function nextRewardAfter(count) {
        var activePct = (findActiveTier(count, state.tiers) || { pct: 0 }).pct;
        var best = null;
        state.tiers.forEach(function (t) {
          if (t.count > count && t.pct > activePct && (!best || t.count < best.count)) {
            best = { count: t.count, tier: t.pct + '% off', gifts: [] };
          }
        });
        state.gifts.forEach(function (g) {
          if (g.trigger <= count) return;
          if (best && g.trigger > best.count) return;
          if (best && g.trigger === best.count) {
            best.gifts.push(g.name);
          } else {
            best = { count: g.trigger, tier: '', gifts: [g.name] };
          }
        });
        if (!best) return null;
        var parts = [];
        if (best.tier) parts.push(best.tier);
        var giftLabel = giftPhrase(best.gifts, false, unlockedGifts(count, state.gifts).length > 0);
        if (giftLabel) parts.push(giftLabel);
        return { count: best.count, label: parts.join(' + ') };
      }

      function setProgressUI(progressEl, barEl, totals) {
        // The bar fills toward the LAST reward (top tier or final gift).
        var goal = lastRewardCount();
        if (barEl && goal) {
          var fill = Math.max(0, Math.min(100, Math.round((totals.count / goal) * 100)));
          barEl.style.width = fill + '%';
        }
        if (!progressEl) return;

        var nextReward = nextRewardAfter(totals.count);
        progressEl.classList.toggle('is-unlocked', !nextReward);
        if (!nextReward) {
          // Everything unlocked — best active tier (when the offer has discount tiers)
          // plus every gift by name. Gifts-only offers list just the gifts.
          var topReward = terminalRewardLabel(totals.count, state.tiers, state.gifts);
          progressEl.innerHTML = '<strong>' + escapeHTML(topReward) + '</strong> Unlocked!';
          return;
        }
        var diff = nextReward.count - totals.count;
        var unit = diff === 1 ? 'item' : 'items';
        var lead = totals.count === 0 ? ('Add ' + diff + ' ' + unit) : ('Add ' + diff + ' more ' + unit);
        progressEl.innerHTML = lead + ' to unlock <strong>' + escapeHTML(nextReward.label) + '</strong>';
      }

      // Swaps a CTA label between "Add N more items" (empty) and the configured
      // checkout label. `key` caches each button's original label separately.
      var ctaBaseLabels = {};
      function setCtaLabel(labelEl, totals, key) {
        if (!labelEl) return;
        if (!(key in ctaBaseLabels)) {
          ctaBaseLabels[key] = (labelEl.textContent || '').trim() || 'Checkout';
        }
        if (checkoutGuard.pending()) return;
        var firstUnlock = firstRewardCount(state.tiers, state.gifts);
        var unit = firstUnlock === 1 ? 'item' : 'items';
        labelEl.textContent = totals.count === 0
          ? ('Add ' + firstUnlock + ' more ' + unit)
          : ctaBaseLabels[key];
      }

      function updateDesktopPanel(totals) {
        setProgressUI(els.progress, els.progressBar, totals);
        setCtaLabel(els.checkoutLabel, totals, 'desktop');
      }

      function giftDisplayLabel() {
        if (els.gift) {
          var v = els.gift.querySelector('.based-byob-pp__gift-value');
          if (v && v.textContent) return v.textContent;
        }
        return 'Free gifts unlocked';
      }

      function renderTotalsInto(refs, totals) {
        if (refs.subtotal) refs.subtotal.textContent = moneyFmt(totals.subtotalCents);
        if (refs.savings) refs.savings.textContent = '−' + moneyFmt(totals.savingsCents);
        if (refs.savingsRow) refs.savingsRow.hidden = totals.savingsCents === 0;
        if (refs.savingsLabel) refs.savingsLabel.textContent = 'Savings (' + totals.pct + '%' + (totals.giftValueCents > 0 ? ' + gifts' : '') + ')';
        if (refs.total) refs.total.textContent = moneyFmt(totals.totalCents);
        if (refs.discountChip) {
          refs.discountChip.hidden = totals.pct === 0;
          refs.discountChip.textContent = totals.pct > 0 ? totals.pct + '% off' : '';
        }
        if (refs.checkoutTotal && !checkoutGuard.pending()) refs.checkoutTotal.textContent = totals.count > 0 ? ' - ' + moneyFmt(totals.totalCents) : '';
        if (refs.checkout) refs.checkout.disabled = checkoutGuard.pending() || totals.count === 0;
        // Progress text is owned by setProgressUI (called after this in renderPanel).
      }

      function renderMobileBar() {
        var totals = computeTotals(state.selections, state.tiers, state.gifts);
        var topTier = state.tiers[state.tiers.length - 1] || { count: 6 };
        if (els.mobileCount) els.mobileCount.textContent = totals.count;
        var mobileMsrp = ensureMobileMsrpEl();
        if (mobileMsrp) {
          mobileMsrp.hidden = totals.count === 0;
          mobileMsrp.textContent = totals.count > 0 ? 'MSRP ' + moneyFmt(totals.subtotalCents) : '';
        }
        if (els.mobileTotal) els.mobileTotal.textContent = moneyFmt(totals.totalCents);
        if (els.mobileDiscountChip) {
          els.mobileDiscountChip.hidden = totals.pct === 0;
          els.mobileDiscountChip.textContent = totals.pct > 0 ? totals.pct + '% off' : '';
        }
        if (els.mobileCheckoutTotal && !checkoutGuard.pending()) els.mobileCheckoutTotal.textContent = totals.count > 0 ? mobileTotalSep + moneyFmt(totals.totalCents) : '';
        if (els.mobileCheckout) els.mobileCheckout.disabled = checkoutGuard.pending() || totals.count === 0;
        if (els.mobileSlots && els.mobileSlots.length) {
          els.mobileSlots.forEach(function (slot, index) {
            var sel = state.selections[index];
            slot.classList.toggle('based-byob-pp__slot--empty', !sel);
            slot.classList.toggle('based-byob-pp__mobile-slot--filled', !!sel);
            renderMobileSlot(slot, sel, index);
          });
        }
        if (els.mobileTiers && els.mobileTiers.length) {
          els.mobileTiers.forEach(function (tier) {
            var count = parseInt(tier.getAttribute('data-byob-mobile-tier'), 10);
            if (totals.count >= count) tier.setAttribute('data-active', 'hit');
            else tier.removeAttribute('data-active');
          });
        }
        if (els.mobileGift && state.gifts.length) {
          els.mobileGift.hidden = unlockedGifts(totals.count, state.gifts).length === 0;
        }
        // Free-gift tiles in the collapsed bar: each lights up at its own trigger
        // (syncGiftCardStates); the bar attribute flips when all are unlocked.
        if (els.mobileBar && state.gifts.length) {
          els.mobileBar.setAttribute('data-gifts-unlocked', allGiftsUnlocked(totals.count, state.gifts) ? '1' : '0');
          syncGiftCardStates(totals.count);
        }
        setProgressUI(els.mobileProgress, els.mobileProgressBar, totals);
        setCtaLabel(els.mobileCheckoutLabel, totals, 'mobile');
      }

      function ensureMobileMsrpEl() {
        if (els.mobileMsrp) return els.mobileMsrp;
        if (!els.mobileTotal || !els.mobileTotal.parentNode) return null;
        els.mobileMsrp = document.createElement('span');
        els.mobileMsrp.setAttribute('data-byob-mobile-msrp', '');
        els.mobileMsrp.hidden = true;
        els.mobileMsrp.textContent = 'MSRP ' + moneyFmt(0);
        els.mobileTotal.parentNode.insertBefore(els.mobileMsrp, els.mobileTotal);
        return els.mobileMsrp;
      }

      function renderMobileSlot(slot, sel, index) {
        var key = sel ? slotRenderKey(sel, index) : 'empty:' + index;
        if (slot.getAttribute('data-byob-render-key') === key) return;
        slot.setAttribute('data-byob-render-key', key);
        // Only manage the image overlay; the reward label (if any) stays in place
        // and is hidden via CSS when the slot is filled.
        var existing = slot.querySelector('.based-byob-pp__mobile-slot-img');
        if (existing) slot.removeChild(existing);
        if (!sel) return;
        var img = document.createElement('img');
        img.className = 'based-byob-pp__mobile-slot-img';
        img.src = sel.image || '';
        img.alt = '';
        img.loading = 'eager';
        img.decoding = 'async';
        slot.appendChild(img);
      }

      // Event handlers.
      function onSectionClick(e) {
        var detailClose = e.target.closest('[data-byob-detail-close]');
        if (detailClose) { e.preventDefault(); closeProductDetail(); return; }
        var detailAdd = e.target.closest('[data-byob-detail-add]');
        if (detailAdd) { e.preventDefault(); handleDetailAdd(); return; }
        var detailOpen = e.target.closest('[data-byob-detail-open]');
        if (detailOpen) { e.preventDefault(); if (DETAIL_OVERLAY_ENABLED) openProductDetail(detailOpen.closest('[data-byob-card]')); return; }
        var scentClose = e.target.closest('[data-byob-scent-close]');
        if (scentClose) { e.preventDefault(); closeScentSheet(); return; }
        var scentOption = e.target.closest('[data-byob-scent-option]');
        if (scentOption) { e.preventDefault(); handleScentOptionClick(scentOption); return; }
        var addBtn = e.target.closest('[data-byob-add]');
        if (addBtn) { e.preventDefault(); handleAdd(addBtn.closest('[data-byob-card]')); return; }
        var qtyInc = e.target.closest('[data-byob-qty-inc]');
        if (qtyInc) { e.preventDefault(); handleAdd(qtyInc.closest('[data-byob-card]')); return; }
        var qtyDec = e.target.closest('[data-byob-qty-dec]');
        if (qtyDec) { e.preventDefault(); handleQtyDec(qtyDec.closest('[data-byob-card]')); return; }
        var scentDot = e.target.closest('[data-scent]');
        if (scentDot) { e.preventDefault(); handleScentDotClick(scentDot); return; }
        var tabBtn = e.target.closest('[data-byob-tab]');
        if (tabBtn) { state.activeTab = tabBtn.getAttribute('data-byob-tab'); renderAll(); return; }
        var removeBtn = e.target.closest('[data-byob-remove]');
        if (removeBtn) { handleRemove(parseInt(removeBtn.getAttribute('data-byob-remove'), 10)); return; }
        var checkoutBtn = e.target.closest('[data-byob-checkout], [data-byob-drawer-checkout], [data-byob-mobile-checkout]');
        if (checkoutBtn) { handleCheckout(checkoutBtn); return; }
        var openBtn = e.target.closest('[data-byob-mobile-open]');
        if (openBtn) { toggleMobileExpanded(); return; }
        // Tapping a collapsed slot tile (product image) expands the bar.
        var mobileTile = e.target.closest('[data-byob-mobile-slot]');
        if (mobileTile) { setMobileExpanded(true); return; }
      }
      root.addEventListener('click', onSectionClick);

      root.addEventListener('pointerdown', function (e) {
        var card = e.target.closest('[data-byob-card]');
        if (card && !card.classList.contains('based-byob-pp__card--oos')) {
          card.setAttribute('data-pressing', '1');
        }
      });

      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (type) {
        root.addEventListener(type, function () {
          root.querySelectorAll('[data-byob-card][data-pressing="1"]').forEach(function (card) {
            card.removeAttribute('data-pressing');
          });
        });
      });

      root.addEventListener('keydown', function (e) {
        // Modal Escape close + Tab focus traps.
        if (els.detail && els.detail.getAttribute('data-open') === '1') {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeProductDetail();
            return;
          }
          if (e.key === 'Tab') {
            var detailFocusables = getDetailFocusables();
            if (detailFocusables.length === 0) {
              e.preventDefault();
              return;
            }
            var detailFirst = detailFocusables[0];
            var detailLast = detailFocusables[detailFocusables.length - 1];
            if (e.shiftKey && document.activeElement === detailFirst) {
              e.preventDefault();
              detailLast.focus();
            } else if (!e.shiftKey && document.activeElement === detailLast) {
              e.preventDefault();
              detailFirst.focus();
            }
            return;
          }
        }

        if (els.scentSheet && els.scentSheet.getAttribute('data-open') === '1') {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeScentSheet();
            return;
          }
          if (e.key === 'Tab') {
            var scentFocusables = getScentFocusables();
            if (scentFocusables.length === 0) {
              e.preventDefault();
              return;
            }
            var scentFirst = scentFocusables[0];
            var scentLast = scentFocusables[scentFocusables.length - 1];
            if (e.shiftKey && document.activeElement === scentFirst) {
              e.preventDefault();
              scentLast.focus();
            } else if (!e.shiftKey && document.activeElement === scentLast) {
              e.preventDefault();
              scentFirst.focus();
            }
            return;
          }
        }

        if (els.drawer && els.drawer.getAttribute('data-open') === '1') {
          if (e.key === 'Escape') {
            e.preventDefault();
            closeDrawer();
            return;
          }
          if (e.key === 'Tab') {
            var focusables = getDrawerFocusables();
            if (focusables.length === 0) {
              e.preventDefault();
              return;
            }
            var first = focusables[0];
            var last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) {
              e.preventDefault();
              last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
              e.preventDefault();
              first.focus();
            }
            return;
          }
        }

        // Tablist arrow-key navigation (WAI-ARIA tab pattern).
        var currentTab = e.target.closest('[data-byob-tab]');
        if (currentTab && (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Home' || e.key === 'End')) {
          var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-byob-tab]'));
          var idx = tabs.indexOf(currentTab);
          var next = idx;
          if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
          if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== idx) {
            e.preventDefault();
            state.activeTab = tabs[next].getAttribute('data-byob-tab');
            tabs[next].focus();
            renderAll();
          }
        }
      });

      root.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-byob-scent-edit]');
        if (!sel) return;
        var index = parseInt(sel.getAttribute('data-byob-scent-edit'), 10);
        var opt = sel.options[sel.selectedIndex];
        var newVariantId = parseInt(opt.getAttribute('data-variant-id'), 10);
        var newScent = opt.value;
        var currentSelection = state.selections[index] || {};
        var selectionCard = null;
        Array.prototype.slice.call(root.querySelectorAll('[data-byob-card]')).some(function (candidate) {
          if (String(candidate.getAttribute('data-product-id')) !== String(currentSelection.productId)) return false;
          selectionCard = candidate;
          return true;
        });
        var selectedVariant = selectionCard && parseVariants(selectionCard).find(function (variant) {
          return String(variant.id) === String(newVariantId);
        });
        if (!selectedVariant || !selectedVariant.available) {
          showError((currentSelection.title || 'Product') + ' in ' + newScent + ' is sold out. Pick a different scent.');
          renderAll();
          return;
        }
        var newVariantImage = opt.getAttribute('data-variant-image') || '';
        var newVariantCardImage = opt.getAttribute('data-variant-card-image') || '';
        var newImage = selectionImageForVariant(currentSelection.image || '', newVariantImage, currentSelection.cardImageLocked ? 'true' : 'false', newVariantCardImage);
        state.selections = editScent(
          state.selections,
          index,
          newVariantId,
          newScent,
          newImage,
          selectedVariant.price
        );
        var activeCardVariant = findCardVariant(
          parseVariants(selectionCard),
          selectionCard.getAttribute('data-picked-scent') || ''
        );
        if (activeCardVariant) syncCardPriceBinding(selectionCard, activeCardVariant, moneyFmt);
        renderAll();
      });

      function handleScentDotClick(dot) {
        var card = dot.closest('[data-byob-card]');
        if (!card) return;
        if (shouldUseScentSheet()) {
          openScentSheet(card, dot);
          return;
        }
        applyScentToCard(card, dot.getAttribute('data-scent'));
      }

      function shouldUseScentSheet() {
        return window.matchMedia && window.matchMedia('(max-width: 700px)').matches;
      }

      function applyScentToCard(card, scent) {
        if (!card || !scent) return;
        card.setAttribute('data-picked-scent', scent);
        var match = findCardVariant(parseVariants(card), scent);
        if (match && match.available) {
          setCardImageForVariant(card, match);
          syncCardPriceBinding(card, match, moneyFmt);
        }
        haptic(6);
        renderAll();
      }

      function setCardImageForVariant(card, variant) {
        if (!card || !variant) return;
        var slotImage = variant.cardImage || '';
        var displayImage = variant.cardImageLarge || slotImage;
        var srcset = variant.cardImageSrcset || '';
        if (!displayImage && cardAllowsVariantImageSwap(card.getAttribute('data-byob-card-image-locked'))) {
          slotImage = variant.image || '';
          displayImage = variant.imageLarge || slotImage;
          srcset = variant.imageSrcset || '';
        }
        if (displayImage) {
          card.setAttribute('data-product-image', slotImage || displayImage);
          card.setAttribute('data-product-image-large', displayImage);
        }
        // v2 cards show the variant's own photo on the card face (pcardImage is
        // only emitted for v2); the curated art above still feeds the slots.
        if (variant.pcardImage) {
          displayImage = variant.pcardImage;
          srcset = variant.pcardImageSrcset || '';
        }
        if (!displayImage) return;
        // Support both card render paths. Exclude the optional v2 hover image:
        // scent changes should update the primary image the shopper sees.
        var img = card.querySelector(
          '.based-byob-pp__card-media img:not(.bbw-pcard__img--hover), ' +
          '.bbw-pcard__media img:not(.bbw-pcard__img--hover)'
        );
        if (!img) return;
        img.src = displayImage;
        if (srcset) img.srcset = srcset;
        else img.removeAttribute('srcset');
      }

      function getScentFocusables() {
        if (!els.scentSheet) return [];
        return Array.prototype.slice.call(els.scentSheet.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      }

      function resolveScentFocusTarget(focusReturn) {
        if (!focusReturn) return null;
        if (focusReturn.element && root.contains(focusReturn.element)) return focusReturn.element;
        var card = resolveScentCard(
          root,
          null,
          focusReturn.productId,
          focusReturn.productHandle
        );
        if (!card) return null;
        var scentDots = Array.prototype.slice.call(card.querySelectorAll('[data-scent]'));
        var matchingDot = scentDots.find(function (dot) {
          return focusReturn.scent && dot.getAttribute('data-scent') === focusReturn.scent;
        });
        return matchingDot || scentDots[0] || null;
      }

      function openScentSheet(card, opener) {
        if (!els.scentSheet || !els.scentOptions) return;
        if (els.scentSheet.getAttribute('data-open') !== '1') {
          scentFocusReturn = {
            element: opener || document.activeElement,
            productId: card.getAttribute('data-product-id') || '',
            productHandle: card.getAttribute('data-product-handle') || '',
            scent: opener ? opener.getAttribute('data-scent') || '' : ''
          };
        }
        scentCloseToken += 1;
        if (scentCloseTimer) {
          clearTimeout(scentCloseTimer);
          scentCloseTimer = null;
        }
        activeScentCard = card;
        els.scentSheet.setAttribute('data-byob-scent-product-id', card.getAttribute('data-product-id') || '');
        els.scentSheet.setAttribute('data-byob-scent-product-handle', card.getAttribute('data-product-handle') || '');
        if (els.scentSheetTitle) {
          els.scentSheetTitle.textContent = card.getAttribute('data-product-title') || 'Choose scent';
        }
        var variants = parseVariants(card);
        var picked = card.getAttribute('data-picked-scent') || '';
        var seen = {};
        var html = '';
        variants.forEach(function (v) {
          if (!v.scent || seen[v.scent]) return;
          seen[v.scent] = true;
          var selected = v.scent === picked;
          var scentStyle = v.scentColor ? ' style="--byob-scent-color:' + escapeAttr(v.scentColor) + '"' : '';
          html += '<button type="button" class="based-byob-pp__scent-option' + (selected ? ' based-byob-pp__scent-option--selected' : '') + '" data-byob-scent-option="' + escapeAttr(v.scent) + '"' + scentStyle + (v.available ? '' : ' disabled aria-disabled="true"') + '>' +
            '<span class="based-byob-pp__scent-option-dot" aria-hidden="true"></span>' +
            '<span class="based-byob-pp__scent-option-label">' + escapeHTML(v.scent) + '</span>' +
            '<span class="based-byob-pp__scent-option-state">' + (v.available ? (selected ? 'Selected' : '') : 'Sold out') + '</span>' +
          '</button>';
        });
        els.scentOptions.innerHTML = html;
        // Send the bundle bar down first, then bring the scent sheet up.
        setMobileBarSuppressed(true);
        els.scentSheet.hidden = false;
        if (!scentSheetOwnsScrollLock) {
          lockBodyScroll();
          scentSheetOwnsScrollLock = true;
        }
        requestAnimationFrame(function () {
          els.scentSheet.setAttribute('data-open', '1');
          var selected = els.scentSheet.querySelector('.based-byob-pp__scent-option--selected');
          var first = selected || els.scentSheet.querySelector('[data-byob-scent-option]:not([disabled])') || els.scentSheet.querySelector('[data-byob-scent-close]');
          if (first) first.focus();
        });
      }

      function closeScentSheet() {
        if (!els.scentSheet || els.scentSheet.hidden || els.scentSheet.getAttribute('data-open') !== '1') return;
        if (scentCloseTimer) {
          clearTimeout(scentCloseTimer);
          scentCloseTimer = null;
        }
        var closeToken = ++scentCloseToken;
        els.scentSheet.removeAttribute('data-open');
        if (scentSheetOwnsScrollLock) {
          unlockBodyScroll();
          scentSheetOwnsScrollLock = false;
        }
        var focusReturn = scentFocusReturn;
        scentFocusReturn = null;
        activeScentCard = null;
        // Let the scent sheet drop first, then bring the bundle bar back up.
        scentCloseTimer = setTimeout(function () {
          if (closeToken !== scentCloseToken) return;
          if (els.scentSheet) els.scentSheet.hidden = true;
          if (els.scentSheet) {
            els.scentSheet.removeAttribute('data-byob-scent-product-id');
            els.scentSheet.removeAttribute('data-byob-scent-product-handle');
          }
          setMobileBarSuppressed(false);
          var focusTarget = resolveScentFocusTarget(focusReturn);
          if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
          scentCloseTimer = null;
        }, prefersReducedMotion() ? 0 : 220);
      }

      function handleScentOptionClick(option) {
        if (!els.scentSheet || els.scentSheet.getAttribute('data-open') !== '1') return;
        var card = resolveScentCard(
          root,
          activeScentCard,
          els.scentSheet && els.scentSheet.getAttribute('data-byob-scent-product-id'),
          els.scentSheet && els.scentSheet.getAttribute('data-byob-scent-product-handle')
        );
        if (!card) return;
        activeScentCard = card;
        applyScentToCard(card, option.getAttribute('data-byob-scent-option'));
        closeScentSheet();
      }

      function handleAdd(card) {
        if (!card) return;
        var variants = parseVariants(card);
        var picked = card.getAttribute('data-picked-scent') || '';
        var match = findCardVariant(variants, picked);

        if (!match) return;
        if (picked && !match.available) {
          showError(card.getAttribute('data-product-title') + ' in ' + picked + ' is sold out. Pick a different scent.');
          return;
        }

        if (state.selections.length >= setCapacity()) {
          showError('Your bundle is full, remove an item to swap.');
          return;
        }

        var landedIndex = state.selections.length;
        var cardImageLockValue = card.getAttribute('data-byob-card-image-locked');
        var cardImageLocked = !cardAllowsVariantImageSwap(cardImageLockValue) || !!match.cardImage;
        var selection = {
          productId: card.getAttribute('data-product-id'),
          productHandle: card.getAttribute('data-product-handle'),
          variantId: match.id,
          scentValue: match.scent || '',
          scents: variants.filter(function (v) { return v.scent; }),
          title: card.getAttribute('data-product-title'),
          image: selectionImageForVariant(card.getAttribute('data-product-image'), match.image || '', cardImageLockValue, match.cardImage || ''),
          cardImageLocked: cardImageLocked,
          price: match.price
        };

        if (audioHooks) audioHooks.onAdd();
        haptic(8);
        state.selections.push(selection);
        renderAll();
        var landedSlot = root.querySelector('[data-byob-slot-index="' + landedIndex + '"]');
        if (landedSlot) {
          landedSlot.setAttribute('data-just-landed', '1');
          setTimeout(function () { landedSlot.removeAttribute('data-just-landed'); }, 400);
        }
        var mobileSlot = root.querySelector('[data-byob-mobile-slot-index="' + landedIndex + '"]');
        if (mobileSlot) {
          mobileSlot.setAttribute('data-just-landed', '1');
          setTimeout(function () { mobileSlot.removeAttribute('data-just-landed'); }, 400);
        }
      }

      function showError(msg) {
        var target = els.error || els.drawerError;
        if (!target) return;
        target.hidden = false;
        target.textContent = msg;
        // Auto-dismiss after a few seconds so the panel doesn't accumulate stale errors.
        if (showError._t) clearTimeout(showError._t);
        showError._t = setTimeout(function () { target.hidden = true; target.textContent = ''; }, 5000);
      }

      function handleRemove(index) {
        state.selections.splice(index, 1);
        if (audioHooks) audioHooks.onRemove();
        haptic(6);
        renderAll();
      }

      // Stepper "−": remove the most-recently-added unit of the active variant.
      function handleQtyDec(card) {
        if (!card) return;
        var activeVariant = findCardVariant(
          parseVariants(card),
          card.getAttribute('data-picked-scent') || ''
        );
        if (!activeVariant) return;

        var index = lastSelectionIndexForVariant(state.selections, activeVariant.id);
        if (index >= 0) handleRemove(index);
      }

      function parseVariants(card) {
        var node = card.querySelector('script[data-byob-variants]');
        var raw = node ? node.textContent : '';
        try { return JSON.parse(raw || '[]'); }
        catch (e) { return []; }
      }

      function parseDetailData(card) {
        var node = card ? card.querySelector('script[data-byob-detail-data]') : null;
        var raw = node ? node.textContent : '';
        try { return JSON.parse(raw || '{}'); }
        catch (e) { return {}; }
      }

      function getDetailFocusables() {
        if (!els.detail) return [];
        return Array.prototype.slice.call(els.detail.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
      }

      function formatDetailCategory(value) {
        var text = String(value || '').replace(/-/g, ' ').trim();
        if (!text) return 'Product detail';
        return text.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      }

      function availableScentLabels(card) {
        var seen = {};
        var labels = [];
        parseVariants(card).forEach(function (v) {
          if (!v.scent || !v.available || seen[v.scent]) return;
          seen[v.scent] = true;
          labels.push(v.scent);
        });
        return labels;
      }

      function detailBasePriceCents(card) {
        var fallback = parseInt(card.getAttribute('data-default-price') || '0', 10) || 0;
        var picked = card.getAttribute('data-picked-scent') || '';
        var match = null;
        parseVariants(card).forEach(function (v) {
          if (picked && v.scent === picked && !match) match = v;
        });
        if (!match) {
          parseVariants(card).forEach(function (v) {
            if (v.available && !match) match = v;
          });
        }
        return match && match.price ? match.price : fallback;
      }

      function renderDetailPrice(card) {
        if (!els.detailPrice) return;
        var baseCents = detailBasePriceCents(card);
        var tier = findActiveTier(state.selections.length, state.tiers);
        var pct = tier ? tier.pct : 0;
        var finalCents = baseCents - Math.round(baseCents * pct / 100);
        if (pct > 0 && finalCents < baseCents) {
          els.detailPrice.innerHTML =
            '<span class="based-byob-pp__detail-price-now">' + escapeHTML(moneyFmt(finalCents)) + '</span>' +
            '<s class="based-byob-pp__detail-price-was">' + escapeHTML(moneyFmt(baseCents)) + '</s>' +
            '<span class="based-byob-pp__detail-price-note">' + pct + '% off in your set</span>';
        } else {
          els.detailPrice.textContent = moneyFmt(baseCents);
        }
      }

      function setDetailPriceFacts(items) {
        if (!els.detailPriceFacts) return;
        var facts = normalizeExtraList(items, 2);
        els.detailPriceFacts.textContent = facts.join(' · ');
        els.detailPriceFacts.hidden = facts.length === 0;
      }

      function setDetailLoading(isLoading) {
        if (els.detail) {
          if (isLoading) els.detail.setAttribute('data-loading', '1');
          else els.detail.removeAttribute('data-loading');
        }
        if (els.detailLoader) els.detailLoader.hidden = !isLoading;
        if (els.detailPanel) {
          if (isLoading) els.detailPanel.setAttribute('aria-busy', 'true');
          else els.detailPanel.removeAttribute('aria-busy');
        }
      }

      function focusDetailPanel() {
        var first = getDetailFocusables()[0];
        if (first) first.focus();
      }

      function setDetailContent(card) {
        var detail = parseDetailData(card);
        var title = detail.title || card.getAttribute('data-product-title') || 'Product';
        var image = detail.image || card.getAttribute('data-product-image') || '';
        var picked = card.getAttribute('data-picked-scent') || '';
        parseVariants(card).forEach(function (v) {
          if (picked && v.scent === picked && (v.imageLarge || v.image)) {
            image = v.imageLarge || v.image;
          }
        });
        var summary = detail.summary || title + ' is ready for your custom set.';
        var origin = detail.origin || '';
        var scents = availableScentLabels(card);
        var isSoldOut = card.classList.contains('based-byob-pp__card--oos') || detail.available === false;
        var selected = card.getAttribute('data-selected') === '1';

        if (els.detailTitle) els.detailTitle.textContent = title;
        renderDetailPrice(card);
        setDetailPriceFacts([]);
        if (els.detailCategory) els.detailCategory.textContent = formatDetailCategory(detail.category || card.getAttribute('data-category'));
        if (els.detailSummary) els.detailSummary.textContent = summary;
        if (els.detailImage) {
          els.detailImage.src = image;
          els.detailImage.alt = title;
        }
        if (els.detailScents) els.detailScents.textContent = scents.join(', ');
        if (els.detailScentRow) els.detailScentRow.hidden = scents.length === 0;
        if (els.detailOrigin) els.detailOrigin.textContent = origin;
        if (els.detailOriginRow) els.detailOriginRow.hidden = !origin;
        if (els.detailAdd) {
          els.detailAdd.disabled = isSoldOut;
          els.detailAdd.textContent = isSoldOut ? 'Sold out' : (selected ? 'Add another' : 'Add to set');
        }
      }

      function resetDetailExtras() {
        if (!els.detailExtra || !els.detailExtraContent || !els.detailExtraStatus) return;
        els.detailExtra.hidden = false;
        els.detailExtraStatus.hidden = false;
        els.detailExtraStatus.textContent = 'Loading product details...';
        els.detailExtraContent.textContent = '';
        setDetailPriceFacts([]);
      }

      function hideDetailExtras() {
        if (!els.detailExtra) return;
        els.detailExtra.hidden = true;
        if (els.detailExtraContent) els.detailExtraContent.textContent = '';
        if (els.detailExtraStatus) els.detailExtraStatus.hidden = true;
        setDetailPriceFacts([]);
      }

      function detailExtrasUrl(handle) {
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (rootPath.slice(-1) !== '/') rootPath += '/';
        return rootPath + 'products/' + encodeURIComponent(handle) + '?section_id=based-byob-detail-data';
      }

      function normalizeExtraList(items, limit) {
        var seen = {};
        var list = [];
        if (!Array.isArray(items)) return list;
        items.forEach(function (item) {
          var text = String(item || '').replace(/\s+/g, ' ').trim();
          var key = text.toLowerCase();
          if (!text || seen[key] || list.length >= limit) return;
          seen[key] = true;
          list.push(text);
        });
        return list;
      }

      function appendExtraSection(parent, heading, items) {
        var list = normalizeExtraList(items, 6);
        if (!list.length) return;
        var section = document.createElement('section');
        section.className = 'based-byob-pp__detail-extra-section';
        var title = document.createElement('p');
        title.className = 'based-byob-pp__detail-extra-heading';
        title.textContent = heading;
        var ul = document.createElement('ul');
        ul.className = 'based-byob-pp__detail-extra-list';
        list.forEach(function (text) {
          var li = document.createElement('li');
          li.className = 'based-byob-pp__detail-extra-item';
          li.textContent = text;
          ul.appendChild(li);
        });
        section.appendChild(title);
        section.appendChild(ul);
        parent.appendChild(section);
      }

      function renderDetailExtras(data) {
        if (!els.detailExtra || !els.detailExtraContent || !els.detailExtraStatus) return;
        els.detailExtraContent.textContent = '';
        setDetailPriceFacts(data.facts);
        appendExtraSection(els.detailExtraContent, 'Best for', data.bestFor);
        appendExtraSection(els.detailExtraContent, 'Highlights', data.highlights);
        appendExtraSection(els.detailExtraContent, 'Key ingredients', data.ingredients);
        if (!els.detailExtraContent.children.length) {
          els.detailExtra.hidden = true;
          els.detailExtraStatus.hidden = true;
          return;
        }
        els.detailExtra.hidden = false;
        els.detailExtraStatus.hidden = true;
      }

      function loadDetailExtras(card) {
        if (!els.detailExtra || !card) return Promise.resolve();
        var handle = card.getAttribute('data-product-handle') || '';
        if (!handle) {
          hideDetailExtras();
          return Promise.resolve();
        }
        detailExtraRequest += 1;
        var requestId = detailExtraRequest;
        if (detailExtraCache[handle]) {
          renderDetailExtras(detailExtraCache[handle]);
          return Promise.resolve();
        }
        resetDetailExtras();
        return fetch(detailExtrasUrl(handle), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Detail request failed');
            return response.text();
          })
          .then(function (html) {
            if (requestId !== detailExtraRequest || activeDetailCard !== card) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var node = doc.querySelector('[data-byob-extra-json]');
            if (!node) throw new Error('Detail data missing');
            var data = JSON.parse(node.textContent || '{}');
            detailExtraCache[handle] = data;
            renderDetailExtras(data);
          })
          .catch(function () {
            if (requestId !== detailExtraRequest || activeDetailCard !== card) return;
            hideDetailExtras();
          });
      }

      function openProductDetail(card) {
        if (!card || !els.detail) return;
        if (detailCloseTimer) clearTimeout(detailCloseTimer);
        activeDetailCard = card;
        lastFocusedBeforeDetail = document.activeElement;
        setDetailContent(card);
        var handle = card.getAttribute('data-product-handle') || '';
        var shouldHoldForDetails = !!(handle && !detailExtraCache[handle]);
        setDetailLoading(shouldHoldForDetails);
        var detailReady = loadDetailExtras(card);
        els.detail.hidden = false;
        lockBodyScroll();
        setBackgroundInert(true);
        requestAnimationFrame(function () {
          els.detail.setAttribute('data-open', '1');
          if (shouldHoldForDetails && els.detailLoader) els.detailLoader.focus();
          else focusDetailPanel();
        });
        detailReady.then(function () {
          if (!els.detail || els.detail.hidden || activeDetailCard !== card) return;
          setDetailLoading(false);
          requestAnimationFrame(focusDetailPanel);
        });
      }

      function closeProductDetail() {
        if (!els.detail || els.detail.hidden) return;
        els.detail.removeAttribute('data-open');
        setDetailLoading(false);
        unlockBodyScroll();
        setBackgroundInert(false);
        var focusTarget = lastFocusedBeforeDetail;
        lastFocusedBeforeDetail = null;
        activeDetailCard = null;
        detailExtraRequest += 1;
        detailCloseTimer = setTimeout(function () {
          if (els.detail) els.detail.hidden = true;
          if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus();
        }, prefersReducedMotion() ? 0 : 260);
      }

      function handleDetailAdd() {
        var card = activeDetailCard;
        if (!card || card.classList.contains('based-byob-pp__card--oos')) return;
        closeProductDetail();
        setTimeout(function () { handleAdd(card); }, prefersReducedMotion() ? 0 : 170);
      }

      // Drawer modal a11y: focus trap, Escape close, inert backgrounded content,
      // restore focus to the trigger on close. role="dialog" + aria-modal="true"
      // are declared on the panel, so behavior must match the contract.
      var lastFocusedBeforeDrawer = null;
      var drawerCloseTimer = null;

      function getDrawerFocusables() {
        if (!els.drawer) return [];
        return Array.prototype.slice.call(els.drawer.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(function (el) {
          // Visibility check: focusables inside hidden subtrees should be skipped.
          return el.offsetParent !== null || el === document.activeElement;
        });
      }

      function setBackgroundInert(yes) {
        var inner = root.querySelector('.based-byob-pp__inner');
        if (!inner) return;
        Array.prototype.forEach.call(inner.children, function (child) {
          if (child === els.drawer || child === els.detail || child === els.scentSheet) return;
          if (yes) child.setAttribute('inert', '');
          else child.removeAttribute('inert');
        });
      }

      // Expand/collapse the bottom bar in place to reveal the detailed set view.
      // (Replaces the old modal drawer — no overlay, no body-scroll lock.)
      function setMobileExpanded(on) {
        if (!els.mobileBar) return;
        var was = els.mobileBar.getAttribute('data-expanded') === '1';
        if (was === on) { updateMobileScrim(); return; }
        els.mobileBar.setAttribute('data-expanded', on ? '1' : '0');
        var btn = els.mobileBar.querySelector('[data-byob-mobile-open]');
        if (btn) {
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
          btn.setAttribute('aria-label', on ? 'Hide bundle details' : 'Show bundle details');
        }
        // Lock page scroll while expanded (balanced with the state change above).
        if (on) lockBodyScroll(); else unlockBodyScroll();
        updateMobileScrim();
      }
      function toggleMobileExpanded() {
        if (!els.mobileBar) return;
        setMobileExpanded(els.mobileBar.getAttribute('data-expanded') !== '1');
      }
      // Temporarily slide the bar down (e.g. while the scent sheet is up) without
      // losing its is-visible state, so it slides back when un-suppressed.
      function setMobileBarSuppressed(on) {
        if (!els.mobileBar) return;
        els.mobileBar.classList.toggle('is-suppressed', on);
        updateMobileScrim();
      }
      // Dim the page behind the expanded bar (but not while it's suppressed).
      function updateMobileScrim() {
        if (!mobileScrim || !els.mobileBar) return;
        var show = els.mobileBar.getAttribute('data-expanded') === '1' &&
                   !els.mobileBar.classList.contains('is-suppressed') &&
                   els.mobileBar.classList.contains('is-visible');
        mobileScrim.classList.toggle('is-visible', show);
      }

      function preferredDrawerSnap() {
        var topTier = state.tiers[state.tiers.length - 1] || { count: 6 };
        var fullAt = Math.max(4, topTier.count - 2);
        return state.selections.length >= fullAt ? 'full' : 'peek';
      }

      function openDrawer(snap) {
        if (!els.drawer) return;
        if (drawerCloseTimer) clearTimeout(drawerCloseTimer);
        lastFocusedBeforeDrawer = document.activeElement;
        els.drawer.hidden = false;
        els.drawer.setAttribute('data-snap', snap || 'peek');
        lockBodyScroll();
        setBackgroundInert(true);
        requestAnimationFrame(function () {
          els.drawer.setAttribute('data-open', '1');
          root.setAttribute('data-byob-pp-drawer-open', '1');
        });
        // Focus the first focusable inside the drawer (typically the close button).
        var first = getDrawerFocusables()[0];
        if (first) {
          // Defer one frame so the inert toggle settles before focus shift.
          setTimeout(function () { first.focus(); }, 0);
        }
      }

      function closeDrawer() {
        if (!els.drawer || els.drawer.hidden) return;
        els.drawer.removeAttribute('data-open');
        els.drawer.removeAttribute('data-dragging');
        els.drawer.removeAttribute('data-snap');
        root.removeAttribute('data-byob-pp-drawer-open');
        unlockBodyScroll();
        setBackgroundInert(false);
        var focusTarget = lastFocusedBeforeDrawer;
        lastFocusedBeforeDrawer = null;
        drawerCloseTimer = setTimeout(function () {
          els.drawer.hidden = true;
          if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus();
          }
        }, prefersReducedMotion() ? 200 : 420);
      }

      function handleCheckout(btn) {
        if (state.selections.length === 0) return;
        if (!checkoutGuard.begin()) return;
        var isDrawer = btn.matches('[data-byob-drawer-checkout]');
        var isMobile = btn.matches('[data-byob-mobile-checkout]');
        var errEl = checkoutErrorTarget(els, isDrawer, isMobile);
        if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
        [els.checkout, els.drawerCheckout, els.mobileCheckout].forEach(function (checkoutBtn) {
          if (checkoutBtn) checkoutBtn.disabled = true;
        });
        btn.setAttribute('aria-busy', 'true');
        btn.setAttribute('data-loading', 'true');
        var totalSpan = btn.querySelector(isDrawer ? '[data-byob-drawer-checkout-total]' : (isMobile ? '[data-byob-mobile-checkout-total]' : '[data-byob-checkout-total]'));
        var mobileLabel = isMobile ? btn.querySelector('[data-byob-mobile-checkout-label]') : null;
        var deskLabel = isMobile ? null : btn.querySelector(isDrawer ? '[data-byob-drawer-checkout-label]' : '[data-byob-checkout-label]');
        // Loading state = ONLY "Processing…" — the CTA label is replaced, not appended to.
        if (mobileLabel) {
          mobileLabel.textContent = 'Processing…';
          if (totalSpan) totalSpan.textContent = '';
        } else {
          if (deskLabel) deskLabel.textContent = 'Processing…';
          if (totalSpan) totalSpan.textContent = '';
        }

        var payload = buildCartPayload(state.selections, state.gifts);
        var initiatedAt = String(Date.now());
        var codes = getDiscountCodes();
        // Wrap each fetch so cart setup aborts on any non-2xx and shows an error.
        function step(url, body, label) {
          var opts = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
          };
          if (body) opts.body = JSON.stringify(body);
          return fetch(url, opts).then(function (r) {
            return r.text().then(function (text) {
              var json = null;
              if (text) {
                try { json = JSON.parse(text); } catch (parseError) { json = null; }
              }
              if (!r.ok) {
                var msg = (json && json.description) ? json.description : (label + ' failed (' + r.status + ').');
                var err = new Error(msg);
                err.step = label;
                err.status = r.status;
                err.body = text || '';
                throw err;
              }
              return json;
            });
          });
        }

        function ajaxCheckout() {
          return step('/cart/clear.js', null, 'Cart clear').then(function () {
            return step('/cart/add.js', { items: payload }, 'Cart add');
          }).then(function () {
            return step('/cart/update.js', {
              discount: codes.join(','),
              attributes: {
                byob_session: 'true',
                byob_initiated_at: initiatedAt
              }
            }, 'Cart attribute');
          }).then(function (updatedCart) {
            if (!updatedCart || !updatedCart.attributes || String(updatedCart.attributes.byob_session || '') !== 'true') {
              throw new Error('Set discount could not be confirmed. Please try again.');
            }
            return fetch('/cart.js').then(function (response) {
              if (!response.ok) throw new Error('Set cart could not be confirmed. Please try again.');
              return response.json();
            });
          }).then(function (cart) {
            if (!cart || !Array.isArray(cart.items) || !cart.attributes ||
                String(cart.attributes.byob_session || '') !== 'true' ||
                !cart.items.some(function (item) {
                  return item && item.properties && item.properties._byob_item === 'true' && item.properties._byob_gift !== 'true';
                })) {
              throw new Error('Set cart could not be confirmed. Please try again.');
            }
            // Send discount codes on the checkout URL in one hop. Nested
            // /discount/CODE?redirect=... chains can lose the checkout redirect in
            // Shopify theme preview sessions.
            verifyOfferCodes(cart.discount_codes, codes, payload);
            window.location = checkoutDestination(codes);
          });
        }

        function storefrontCheckout() {
          return createStorefrontCart(payload, codes, initiatedAt).then(function (checkoutUrl) {
            window.location = checkoutUrl;
          });
        }

        var checkoutFlow;
        if (!codes.length) {
          checkoutFlow = Promise.reject(new Error('Set discounts are unavailable. Please try again.'));
        } else if (storefrontAccessToken()) {
          checkoutFlow = storefrontCheckout().catch(function (e) {
            if (window.console && typeof window.console.warn === 'function') {
              window.console.warn('[BYOB] Storefront cartCreate failed. Falling back to AJAX cart checkout.', e);
            }
            return ajaxCheckout();
          });
        } else {
          checkoutFlow = ajaxCheckout();
        }

        checkoutFlow.catch(function (e) {
          checkoutGuard.end();
          btn.removeAttribute('aria-busy');
          btn.removeAttribute('data-loading');
          renderAll();
          if (errEl) { errEl.hidden = false; errEl.textContent = e.message || 'Something went wrong. Try again.'; }
        });
      }

      function escapeHTML(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
        });
      }
      function escapeAttr(s) { return escapeHTML(s).replace(/'/g, '&#39;'); }

      initCardTilt(root);
      initGlobalEscapeClose();
      initGlobalDrawerDrag();
      audioHooks = initAudio(root);
      syncAllCardPriceBindings();
      renderAll();
      // A shopper can interact before the app embed finishes loading. Recalculate
      // once Intelligems becomes ready so any early native-price render is replaced
      // with the shopper's assigned test price without requiring another click.
      if (!(window.igData && window.igData.price && typeof window.igData.price.getPriceByVariantId === 'function')) {
        window.addEventListener('ig:ready', function () {
          syncAllCardPriceBindings();
          renderAll();
        }, { once: true });
      }
      initMobileBarReveal();
      initMobileBarPortal();

      // Move the fixed bar out to <body> so its z-index isn't trapped in the
      // section's stacking context (the footer's isolate context was painting
      // over it). Re-bind the section click handler so the bar's buttons work.
      function initMobileBarPortal() {
        var bar = els.mobileBar;
        if (!bar || bar.parentNode === document.body) return;
        document.body.appendChild(bar);
        // Dim-background scrim, parked just under the bar.
        mobileScrim = document.createElement('div');
        mobileScrim.className = 'based-byob-pp__mobile-scrim';
        mobileScrim.setAttribute('aria-hidden', 'true');
        document.body.appendChild(mobileScrim);
        bar.addEventListener('click', onSectionClick);
        // Collapse the expanded bar when clicking outside it. Capture phase so the
        // first outside tap only dismisses the menu (it doesn't fall through and
        // trigger whatever is underneath).
        document.addEventListener('click', function (e) {
          if (bar.getAttribute('data-expanded') !== '1') return;
          if (e.target.closest('[data-byob-mobile-bar]')) return;
          e.preventDefault();
          e.stopPropagation();
          setMobileExpanded(false);
        }, true);
        // Collapse on Escape regardless of focus.
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && bar.getAttribute('data-expanded') === '1') {
            setMobileExpanded(false);
          }
        });
      }

      // Reveal the mobile bar (slide up) once the first product row is fully
      // visible — i.e. the first card's bottom (its CTA) has reached the
      // viewport bottom — and keep it shown while scrolled below that point.
      function initMobileBarReveal() {
        var bar = els.mobileBar;
        if (!bar) return;
        var firstCard = root.querySelector('[data-byob-card]');
        if (!firstCard) { bar.classList.add('is-visible'); return; }
        // bbw only: once the footer climbs to the middle of the viewport the
        // shopper has scrolled out of the builder, so the bar slides back down
        // the same way it came up (dropping is-visible returns it to the base
        // translateY(120%) on the same transition). The classic page keeps its
        // original behaviour of staying up to the bottom of the document.
        var footer = bbwSkin ? document.querySelector('.bbw-footer, footer[role="contentinfo"]') : null;
        var ticking = false;
        function check() {
          ticking = false;
          var rect = firstCard.getBoundingClientRect();
          var pastFirstRow = rect.bottom <= window.innerHeight;
          var atFooter = false;
          if (footer) atFooter = footer.getBoundingClientRect().top <= window.innerHeight / 2;
          bar.classList.toggle('is-visible', pastFirstRow && !atFooter);
          // An expanded bar that slides away must take its backdrop with it.
          updateMobileScrim();
        }
        function onScroll() {
          if (!ticking) { ticking = true; requestAnimationFrame(check); }
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        check();
      }
    }
  })();
